var items = {
  "block.minecraft.acacia_button": "아카시아나무 버튼",
  "block.minecraft.acacia_door": "아카시아나무 문",
  "block.minecraft.acacia_fence": "아카시아나무 울타리",
  "block.minecraft.acacia_fence_gate": "아카시아나무 울타리 문",
  "block.minecraft.acacia_hanging_sign": "아카시아나무 매다는 표지판",
  "block.minecraft.acacia_leaves": "아카시아나무 잎",
  "block.minecraft.acacia_log": "아카시아나무 원목",
  "block.minecraft.acacia_planks": "아카시아나무 판자",
  "block.minecraft.acacia_pressure_plate": "아카시아나무 압력판",
  "block.minecraft.acacia_sapling": "아카시아나무 묘목",
  "block.minecraft.acacia_shelf": "아카시아나무 선반",
  "block.minecraft.acacia_sign": "아카시아나무 표지판",
  "block.minecraft.acacia_slab": "아카시아나무 반 블록",
  "block.minecraft.acacia_stairs": "아카시아나무 계단",
  "block.minecraft.acacia_trapdoor": "아카시아나무 다락문",
  "block.minecraft.acacia_wall_hanging_sign": "아카시아나무 벽 매다는 표지판",
  "block.minecraft.acacia_wall_sign": "아카시아나무 벽 표지판",
  "block.minecraft.acacia_wood": "아카시아나무",
  "block.minecraft.activator_rail": "활성화 레일",
  "block.minecraft.air": "공기",
  "block.minecraft.allium": "알리움",
  "block.minecraft.amethyst_block": "자수정 블록",
  "block.minecraft.amethyst_cluster": "자수정 군집",
  "block.minecraft.ancient_debris": "고대 잔해",
  "block.minecraft.andesite": "안산암",
  "block.minecraft.andesite_slab": "안산암 반 블록",
  "block.minecraft.andesite_stairs": "안산암 계단",
  "block.minecraft.andesite_wall": "안산암 담장",
  "block.minecraft.anvil": "모루",
  "block.minecraft.attached_melon_stem": "수박이 달린 줄기",
  "block.minecraft.attached_pumpkin_stem": "호박이 달린 줄기",
  "block.minecraft.azalea": "진달래",
  "block.minecraft.azalea_leaves": "진달래 잎",
  "block.minecraft.azure_bluet": "선애기별꽃",
  "block.minecraft.bamboo": "대나무",
  "block.minecraft.bamboo_block": "대나무 블록",
  "block.minecraft.bamboo_button": "대나무 버튼",
  "block.minecraft.bamboo_door": "대나무 문",
  "block.minecraft.bamboo_fence": "대나무 울타리",
  "block.minecraft.bamboo_fence_gate": "대나무 울타리 문",
  "block.minecraft.bamboo_hanging_sign": "대나무 매다는 표지판",
  "block.minecraft.bamboo_mosaic": "대나무 모자이크",
  "block.minecraft.bamboo_mosaic_slab": "대나무 모자이크 반 블록",
  "block.minecraft.bamboo_mosaic_stairs": "대나무 모자이크 계단",
  "block.minecraft.bamboo_planks": "대나무 판자",
  "block.minecraft.bamboo_pressure_plate": "대나무 압력판",
  "block.minecraft.bamboo_sapling": "죽순",
  "block.minecraft.bamboo_shelf": "대나무 선반",
  "block.minecraft.bamboo_sign": "대나무 표지판",
  "block.minecraft.bamboo_slab": "대나무 반 블록",
  "block.minecraft.bamboo_stairs": "대나무 계단",
  "block.minecraft.bamboo_trapdoor": "대나무 다락문",
  "block.minecraft.bamboo_wall_hanging_sign": "대나무 벽 매다는 표지판",
  "block.minecraft.bamboo_wall_sign": "대나무 벽 표지판",
  "block.minecraft.banner.base.black": "검은색 바탕",
  "block.minecraft.banner.base.blue": "파란색 바탕",
  "block.minecraft.banner.base.brown": "갈색 바탕",
  "block.minecraft.banner.base.cyan": "청록색 바탕",
  "block.minecraft.banner.base.gray": "회색 바탕",
  "block.minecraft.banner.base.green": "초록색 바탕",
  "block.minecraft.banner.base.light_blue": "하늘색 바탕",
  "block.minecraft.banner.base.light_gray": "회백색 바탕",
  "block.minecraft.banner.base.lime": "연두색 바탕",
  "block.minecraft.banner.base.magenta": "자홍색 바탕",
  "block.minecraft.banner.base.orange": "주황색 바탕",
  "block.minecraft.banner.base.pink": "분홍색 바탕",
  "block.minecraft.banner.base.purple": "보라색 바탕",
  "block.minecraft.banner.base.red": "빨간색 바탕",
  "block.minecraft.banner.base.white": "하얀색 바탕",
  "block.minecraft.banner.base.yellow": "노란색 바탕",
  "block.minecraft.banner.border.black": "검은색 테두리",
  "block.minecraft.banner.border.blue": "파란색 테두리",
  "block.minecraft.banner.border.brown": "갈색 테두리",
  "block.minecraft.banner.border.cyan": "청록색 테두리",
  "block.minecraft.banner.border.gray": "회색 테두리",
  "block.minecraft.banner.border.green": "초록색 테두리",
  "block.minecraft.banner.border.light_blue": "하늘색 테두리",
  "block.minecraft.banner.border.light_gray": "회백색 테두리",
  "block.minecraft.banner.border.lime": "연두색 테두리",
  "block.minecraft.banner.border.magenta": "자홍색 테두리",
  "block.minecraft.banner.border.orange": "주황색 테두리",
  "block.minecraft.banner.border.pink": "분홍색 테두리",
  "block.minecraft.banner.border.purple": "보라색 테두리",
  "block.minecraft.banner.border.red": "빨간색 테두리",
  "block.minecraft.banner.border.white": "하얀색 테두리",
  "block.minecraft.banner.border.yellow": "노란색 테두리",
  "block.minecraft.banner.bricks.black": "검은색 벽돌 무늬",
  "block.minecraft.banner.bricks.blue": "파란색 벽돌 무늬",
  "block.minecraft.banner.bricks.brown": "갈색 벽돌 무늬",
  "block.minecraft.banner.bricks.cyan": "청록색 벽돌 무늬",
  "block.minecraft.banner.bricks.gray": "회색 벽돌 무늬",
  "block.minecraft.banner.bricks.green": "초록색 벽돌 무늬",
  "block.minecraft.banner.bricks.light_blue": "하늘색 벽돌 무늬",
  "block.minecraft.banner.bricks.light_gray": "회백색 벽돌 무늬",
  "block.minecraft.banner.bricks.lime": "연두색 벽돌 무늬",
  "block.minecraft.banner.bricks.magenta": "자홍색 벽돌 무늬",
  "block.minecraft.banner.bricks.orange": "주황색 벽돌 무늬",
  "block.minecraft.banner.bricks.pink": "분홍색 벽돌 무늬",
  "block.minecraft.banner.bricks.purple": "보라색 벽돌 무늬",
  "block.minecraft.banner.bricks.red": "빨간색 벽돌 무늬",
  "block.minecraft.banner.bricks.white": "하얀색 벽돌 무늬",
  "block.minecraft.banner.bricks.yellow": "노란색 벽돌 무늬",
  "block.minecraft.banner.circle.black": "검은색 원",
  "block.minecraft.banner.circle.blue": "파란색 원",
  "block.minecraft.banner.circle.brown": "갈색 원",
  "block.minecraft.banner.circle.cyan": "청록색 원",
  "block.minecraft.banner.circle.gray": "회색 원",
  "block.minecraft.banner.circle.green": "초록색 원",
  "block.minecraft.banner.circle.light_blue": "하늘색 원",
  "block.minecraft.banner.circle.light_gray": "회백색 원",
  "block.minecraft.banner.circle.lime": "연두색 원",
  "block.minecraft.banner.circle.magenta": "자홍색 원",
  "block.minecraft.banner.circle.orange": "주황색 원",
  "block.minecraft.banner.circle.pink": "분홍색 원",
  "block.minecraft.banner.circle.purple": "보라색 원",
  "block.minecraft.banner.circle.red": "빨간색 원",
  "block.minecraft.banner.circle.white": "하얀색 원",
  "block.minecraft.banner.circle.yellow": "노란색 원",
  "block.minecraft.banner.creeper.black": "검은색 크리퍼 모양",
  "block.minecraft.banner.creeper.blue": "파란색 크리퍼 모양",
  "block.minecraft.banner.creeper.brown": "갈색 크리퍼 모양",
  "block.minecraft.banner.creeper.cyan": "청록색 크리퍼 모양",
  "block.minecraft.banner.creeper.gray": "회색 크리퍼 모양",
  "block.minecraft.banner.creeper.green": "초록색 크리퍼 모양",
  "block.minecraft.banner.creeper.light_blue": "하늘색 크리퍼 모양",
  "block.minecraft.banner.creeper.light_gray": "회백색 크리퍼 모양",
  "block.minecraft.banner.creeper.lime": "연두색 크리퍼 모양",
  "block.minecraft.banner.creeper.magenta": "자홍색 크리퍼 모양",
  "block.minecraft.banner.creeper.orange": "주황색 크리퍼 모양",
  "block.minecraft.banner.creeper.pink": "분홍색 크리퍼 모양",
  "block.minecraft.banner.creeper.purple": "보라색 크리퍼 모양",
  "block.minecraft.banner.creeper.red": "빨간색 크리퍼 모양",
  "block.minecraft.banner.creeper.white": "하얀색 크리퍼 모양",
  "block.minecraft.banner.creeper.yellow": "노란색 크리퍼 모양",
  "block.minecraft.banner.cross.black": "검은색 X자",
  "block.minecraft.banner.cross.blue": "파란색 X자",
  "block.minecraft.banner.cross.brown": "갈색 X자",
  "block.minecraft.banner.cross.cyan": "청록색 X자",
  "block.minecraft.banner.cross.gray": "회색 X자",
  "block.minecraft.banner.cross.green": "초록색 X자",
  "block.minecraft.banner.cross.light_blue": "하늘색 X자",
  "block.minecraft.banner.cross.light_gray": "회백색 X자",
  "block.minecraft.banner.cross.lime": "연두색 X자",
  "block.minecraft.banner.cross.magenta": "자홍색 X자",
  "block.minecraft.banner.cross.orange": "주황색 X자",
  "block.minecraft.banner.cross.pink": "분홍색 X자",
  "block.minecraft.banner.cross.purple": "보라색 X자",
  "block.minecraft.banner.cross.red": "빨간색 X자",
  "block.minecraft.banner.cross.white": "하얀색 X자",
  "block.minecraft.banner.cross.yellow": "노란색 X자",
  "block.minecraft.banner.curly_border.black": "검은색 톱니 테두리",
  "block.minecraft.banner.curly_border.blue": "파란색 톱니 테두리",
  "block.minecraft.banner.curly_border.brown": "갈색 톱니 테두리",
  "block.minecraft.banner.curly_border.cyan": "청록색 톱니 테두리",
  "block.minecraft.banner.curly_border.gray": "회색 톱니 테두리",
  "block.minecraft.banner.curly_border.green": "초록색 톱니 테두리",
  "block.minecraft.banner.curly_border.light_blue": "하늘색 톱니 테두리",
  "block.minecraft.banner.curly_border.light_gray": "회백색 톱니 테두리",
  "block.minecraft.banner.curly_border.lime": "연두색 톱니 테두리",
  "block.minecraft.banner.curly_border.magenta": "자홍색 톱니 테두리",
  "block.minecraft.banner.curly_border.orange": "주황색 톱니 테두리",
  "block.minecraft.banner.curly_border.pink": "분홍색 톱니 테두리",
  "block.minecraft.banner.curly_border.purple": "보라색 톱니 테두리",
  "block.minecraft.banner.curly_border.red": "빨간색 톱니 테두리",
  "block.minecraft.banner.curly_border.white": "하얀색 톱니 테두리",
  "block.minecraft.banner.curly_border.yellow": "노란색 톱니 테두리",
  "block.minecraft.banner.diagonal_left.black": "검은색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.blue": "파란색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.brown": "갈색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.cyan": "청록색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.gray": "회색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.green": "초록색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.light_blue": "하늘색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.light_gray": "회백색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.lime": "연두색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.magenta": "자홍색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.orange": "주황색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.pink": "분홍색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.purple": "보라색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.red": "빨간색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.white": "하얀색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_left.yellow": "노란색 왼쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.black": "검은색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.blue": "파란색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.brown": "갈색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.cyan": "청록색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.gray": "회색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.green": "초록색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.light_blue": "하늘색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.light_gray": "회백색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.lime": "연두색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.magenta": "자홍색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.orange": "주황색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.pink": "분홍색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.purple": "보라색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.red": "빨간색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.white": "하얀색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_right.yellow": "노란색 오른쪽 위로부터의 사선 상부",
  "block.minecraft.banner.diagonal_up_left.black": "검은색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.blue": "파란색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.brown": "갈색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.cyan": "청록색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.gray": "회색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.green": "초록색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.light_blue": "하늘색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.light_gray": "회백색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.lime": "연두색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.magenta": "자홍색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.orange": "주황색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.pink": "분홍색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.purple": "보라색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.red": "빨간색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.white": "하얀색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_left.yellow": "노란색 오른쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.black": "검은색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.blue": "파란색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.brown": "갈색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.cyan": "청록색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.gray": "회색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.green": "초록색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.light_blue": "하늘색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.light_gray": "회백색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.lime": "연두색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.magenta": "자홍색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.orange": "주황색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.pink": "분홍색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.purple": "보라색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.red": "빨간색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.white": "하얀색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.diagonal_up_right.yellow": "노란색 왼쪽 위로부터의 사선 하부",
  "block.minecraft.banner.flow.black": "검은색 흐름",
  "block.minecraft.banner.flow.blue": "파란색 흐름",
  "block.minecraft.banner.flow.brown": "갈색 흐름",
  "block.minecraft.banner.flow.cyan": "청록색 흐름",
  "block.minecraft.banner.flow.gray": "회색 흐름",
  "block.minecraft.banner.flow.green": "초록색 흐름",
  "block.minecraft.banner.flow.light_blue": "하늘색 흐름",
  "block.minecraft.banner.flow.light_gray": "회백색 흐름",
  "block.minecraft.banner.flow.lime": "연두색 흐름",
  "block.minecraft.banner.flow.magenta": "자홍색 흐름",
  "block.minecraft.banner.flow.orange": "주황색 흐름",
  "block.minecraft.banner.flow.pink": "분홍색 흐름",
  "block.minecraft.banner.flow.purple": "보라색 흐름",
  "block.minecraft.banner.flow.red": "빨간색 흐름",
  "block.minecraft.banner.flow.white": "하얀색 흐름",
  "block.minecraft.banner.flow.yellow": "노란색 흐름",
  "block.minecraft.banner.flower.black": "검은색 꽃 모양",
  "block.minecraft.banner.flower.blue": "파란색 꽃 모양",
  "block.minecraft.banner.flower.brown": "갈색 꽃 모양",
  "block.minecraft.banner.flower.cyan": "청록색 꽃 모양",
  "block.minecraft.banner.flower.gray": "회색 꽃 모양",
  "block.minecraft.banner.flower.green": "초록색 꽃 모양",
  "block.minecraft.banner.flower.light_blue": "하늘색 꽃 모양",
  "block.minecraft.banner.flower.light_gray": "회백색 꽃 모양",
  "block.minecraft.banner.flower.lime": "연두색 꽃 모양",
  "block.minecraft.banner.flower.magenta": "자홍색 꽃 모양",
  "block.minecraft.banner.flower.orange": "주황색 꽃 모양",
  "block.minecraft.banner.flower.pink": "분홍색 꽃 모양",
  "block.minecraft.banner.flower.purple": "보라색 꽃 모양",
  "block.minecraft.banner.flower.red": "빨간색 꽃 모양",
  "block.minecraft.banner.flower.white": "하얀색 꽃 모양",
  "block.minecraft.banner.flower.yellow": "노란색 꽃 모양",
  "block.minecraft.banner.globe.black": "검은색 지구 모양",
  "block.minecraft.banner.globe.blue": "파란색 지구 모양",
  "block.minecraft.banner.globe.brown": "갈색 지구 모양",
  "block.minecraft.banner.globe.cyan": "청록색 지구 모양",
  "block.minecraft.banner.globe.gray": "회색 지구 모양",
  "block.minecraft.banner.globe.green": "초록색 지구 모양",
  "block.minecraft.banner.globe.light_blue": "하늘색 지구 모양",
  "block.minecraft.banner.globe.light_gray": "회백색 지구 모양",
  "block.minecraft.banner.globe.lime": "연두색 지구 모양",
  "block.minecraft.banner.globe.magenta": "자홍색 지구 모양",
  "block.minecraft.banner.globe.orange": "주황색 지구 모양",
  "block.minecraft.banner.globe.pink": "분홍색 지구 모양",
  "block.minecraft.banner.globe.purple": "보라색 지구 모양",
  "block.minecraft.banner.globe.red": "빨간색 지구 모양",
  "block.minecraft.banner.globe.white": "하얀색 지구 모양",
  "block.minecraft.banner.globe.yellow": "노란색 지구 모양",
  "block.minecraft.banner.gradient.black": "검은색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.blue": "파란색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.brown": "갈색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.cyan": "청록색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.gray": "회색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.green": "초록색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.light_blue": "하늘색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.light_gray": "회백색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.lime": "연두색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.magenta": "자홍색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.orange": "주황색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.pink": "분홍색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.purple": "보라색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.red": "빨간색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.white": "하얀색 위쪽 그라데이션",
  "block.minecraft.banner.gradient.yellow": "노란색 위쪽 그라데이션",
  "block.minecraft.banner.gradient_up.black": "검은색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.blue": "파란색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.brown": "갈색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.cyan": "청록색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.gray": "회색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.green": "초록색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.light_blue": "하늘색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.light_gray": "회백색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.lime": "연두색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.magenta": "자홍색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.orange": "주황색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.pink": "분홍색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.purple": "보라색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.red": "빨간색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.white": "하얀색 아래쪽 그라데이션",
  "block.minecraft.banner.gradient_up.yellow": "노란색 아래쪽 그라데이션",
  "block.minecraft.banner.guster.black": "검은색 소용돌이",
  "block.minecraft.banner.guster.blue": "파란색 소용돌이",
  "block.minecraft.banner.guster.brown": "갈색 소용돌이",
  "block.minecraft.banner.guster.cyan": "청록색 소용돌이",
  "block.minecraft.banner.guster.gray": "회색 소용돌이",
  "block.minecraft.banner.guster.green": "초록색 소용돌이",
  "block.minecraft.banner.guster.light_blue": "하늘색 소용돌이",
  "block.minecraft.banner.guster.light_gray": "회백색 소용돌이",
  "block.minecraft.banner.guster.lime": "연두색 소용돌이",
  "block.minecraft.banner.guster.magenta": "자홍색 소용돌이",
  "block.minecraft.banner.guster.orange": "주황색 소용돌이",
  "block.minecraft.banner.guster.pink": "분홍색 소용돌이",
  "block.minecraft.banner.guster.purple": "보라색 소용돌이",
  "block.minecraft.banner.guster.red": "빨간색 소용돌이",
  "block.minecraft.banner.guster.white": "하얀색 소용돌이",
  "block.minecraft.banner.guster.yellow": "노란색 소용돌이",
  "block.minecraft.banner.half_horizontal.black": "검은색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.blue": "파란색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.brown": "갈색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.cyan": "청록색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.gray": "회색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.green": "초록색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.light_blue": "하늘색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.light_gray": "회백색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.lime": "연두색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.magenta": "자홍색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.orange": "주황색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.pink": "분홍색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.purple": "보라색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.red": "빨간색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.white": "하얀색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal.yellow": "노란색 중앙 가로선 상부",
  "block.minecraft.banner.half_horizontal_bottom.black": "검은색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.blue": "파란색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.brown": "갈색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "청록색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.gray": "회색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.green": "초록색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "하늘색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "회백색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.lime": "연두색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "자홍색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.orange": "주황색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.pink": "분홍색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.purple": "보라색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.red": "빨간색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.white": "하얀색 중앙 가로선 하부",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "노란색 중앙 가로선 하부",
  "block.minecraft.banner.half_vertical.black": "검은색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.blue": "파란색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.brown": "갈색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.cyan": "청록색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.gray": "회색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.green": "초록색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.light_blue": "하늘색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.light_gray": "회백색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.lime": "연두색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.magenta": "자홍색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.orange": "주황색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.pink": "분홍색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.purple": "보라색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.red": "빨간색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.white": "하얀색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical.yellow": "노란색 중앙 세로선 우측",
  "block.minecraft.banner.half_vertical_right.black": "검은색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.blue": "파란색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.brown": "갈색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.cyan": "청록색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.gray": "회색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.green": "초록색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.light_blue": "하늘색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.light_gray": "회백색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.lime": "연두색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.magenta": "자홍색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.orange": "주황색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.pink": "분홍색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.purple": "보라색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.red": "빨간색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.white": "하얀색 중앙 세로선 좌측",
  "block.minecraft.banner.half_vertical_right.yellow": "노란색 중앙 세로선 좌측",
  "block.minecraft.banner.mojang.black": "검은색 무언가",
  "block.minecraft.banner.mojang.blue": "파란색 무언가",
  "block.minecraft.banner.mojang.brown": "갈색 무언가",
  "block.minecraft.banner.mojang.cyan": "청록색 무언가",
  "block.minecraft.banner.mojang.gray": "회색 무언가",
  "block.minecraft.banner.mojang.green": "초록색 무언가",
  "block.minecraft.banner.mojang.light_blue": "하늘색 무언가",
  "block.minecraft.banner.mojang.light_gray": "회백색 무언가",
  "block.minecraft.banner.mojang.lime": "연두색 무언가",
  "block.minecraft.banner.mojang.magenta": "자홍색 무언가",
  "block.minecraft.banner.mojang.orange": "주황색 무언가",
  "block.minecraft.banner.mojang.pink": "분홍색 무언가",
  "block.minecraft.banner.mojang.purple": "보라색 무언가",
  "block.minecraft.banner.mojang.red": "빨간색 무언가",
  "block.minecraft.banner.mojang.white": "하얀색 무언가",
  "block.minecraft.banner.mojang.yellow": "노란색 무언가",
  "block.minecraft.banner.piglin.black": "검은색 돼지 코",
  "block.minecraft.banner.piglin.blue": "파란색 돼지 코",
  "block.minecraft.banner.piglin.brown": "갈색 돼지 코",
  "block.minecraft.banner.piglin.cyan": "청록색 돼지 코",
  "block.minecraft.banner.piglin.gray": "회색 돼지 코",
  "block.minecraft.banner.piglin.green": "초록색 돼지 코",
  "block.minecraft.banner.piglin.light_blue": "하늘색 돼지 코",
  "block.minecraft.banner.piglin.light_gray": "회백색 돼지 코",
  "block.minecraft.banner.piglin.lime": "연두색 돼지 코",
  "block.minecraft.banner.piglin.magenta": "자홍색 돼지 코",
  "block.minecraft.banner.piglin.orange": "주황색 돼지 코",
  "block.minecraft.banner.piglin.pink": "분홍색 돼지 코",
  "block.minecraft.banner.piglin.purple": "보라색 돼지 코",
  "block.minecraft.banner.piglin.red": "빨간색 돼지 코",
  "block.minecraft.banner.piglin.white": "하얀색 돼지 코",
  "block.minecraft.banner.piglin.yellow": "노란색 돼지 코",
  "block.minecraft.banner.rhombus.black": "검은색 마름모",
  "block.minecraft.banner.rhombus.blue": "파란색 마름모",
  "block.minecraft.banner.rhombus.brown": "갈색 마름모",
  "block.minecraft.banner.rhombus.cyan": "청록색 마름모",
  "block.minecraft.banner.rhombus.gray": "회색 마름모",
  "block.minecraft.banner.rhombus.green": "초록색 마름모",
  "block.minecraft.banner.rhombus.light_blue": "하늘색 마름모",
  "block.minecraft.banner.rhombus.light_gray": "회백색 마름모",
  "block.minecraft.banner.rhombus.lime": "연두색 마름모",
  "block.minecraft.banner.rhombus.magenta": "자홍색 마름모",
  "block.minecraft.banner.rhombus.orange": "주황색 마름모",
  "block.minecraft.banner.rhombus.pink": "분홍색 마름모",
  "block.minecraft.banner.rhombus.purple": "보라색 마름모",
  "block.minecraft.banner.rhombus.red": "빨간색 마름모",
  "block.minecraft.banner.rhombus.white": "하얀색 마름모",
  "block.minecraft.banner.rhombus.yellow": "노란색 마름모",
  "block.minecraft.banner.skull.black": "검은색 해골 모양",
  "block.minecraft.banner.skull.blue": "파란색 해골 모양",
  "block.minecraft.banner.skull.brown": "갈색 해골 모양",
  "block.minecraft.banner.skull.cyan": "청록색 해골 모양",
  "block.minecraft.banner.skull.gray": "회색 해골 모양",
  "block.minecraft.banner.skull.green": "초록색 해골 모양",
  "block.minecraft.banner.skull.light_blue": "하늘색 해골 모양",
  "block.minecraft.banner.skull.light_gray": "회백색 해골 모양",
  "block.minecraft.banner.skull.lime": "연두색 해골 모양",
  "block.minecraft.banner.skull.magenta": "자홍색 해골 모양",
  "block.minecraft.banner.skull.orange": "주황색 해골 모양",
  "block.minecraft.banner.skull.pink": "분홍색 해골 모양",
  "block.minecraft.banner.skull.purple": "보라색 해골 모양",
  "block.minecraft.banner.skull.red": "빨간색 해골 모양",
  "block.minecraft.banner.skull.white": "하얀색 해골 모양",
  "block.minecraft.banner.skull.yellow": "노란색 해골 모양",
  "block.minecraft.banner.small_stripes.black": "검은색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.blue": "파란색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.brown": "갈색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.cyan": "청록색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.gray": "회색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.green": "초록색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.light_blue": "하늘색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.light_gray": "회백색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.lime": "연두색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.magenta": "자홍색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.orange": "주황색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.pink": "분홍색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.purple": "보라색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.red": "빨간색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.white": "하얀색 세로줄 무늬",
  "block.minecraft.banner.small_stripes.yellow": "노란색 세로줄 무늬",
  "block.minecraft.banner.square_bottom_left.black": "검은색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.blue": "파란색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.brown": "갈색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.cyan": "청록색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.gray": "회색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.green": "초록색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.light_blue": "하늘색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.light_gray": "회백색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.lime": "연두색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.magenta": "자홍색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.orange": "주황색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.pink": "분홍색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.purple": "보라색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.red": "빨간색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.white": "하얀색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_left.yellow": "노란색 오른쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.black": "검은색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.blue": "파란색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.brown": "갈색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.cyan": "청록색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.gray": "회색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.green": "초록색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.light_blue": "하늘색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.light_gray": "회백색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.lime": "연두색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.magenta": "자홍색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.orange": "주황색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.pink": "분홍색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.purple": "보라색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.red": "빨간색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.white": "하얀색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_bottom_right.yellow": "노란색 왼쪽 아래 사각형",
  "block.minecraft.banner.square_top_left.black": "검은색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.blue": "파란색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.brown": "갈색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.cyan": "청록색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.gray": "회색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.green": "초록색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.light_blue": "파란색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.light_gray": "회백색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.lime": "연두색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.magenta": "자홍색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.orange": "주황색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.pink": "분홍색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.purple": "보라색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.red": "빨간색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.white": "하얀색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_left.yellow": "노란색 오른쪽 위 사각형",
  "block.minecraft.banner.square_top_right.black": "검은색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.blue": "파란색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.brown": "갈색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.cyan": "청록색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.gray": "회색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.green": "초록색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.light_blue": "하늘색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.light_gray": "회백색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.lime": "연두색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.magenta": "자홍색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.orange": "주황색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.pink": "분홍색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.purple": "보라색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.red": "빨간색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.white": "하얀색 왼쪽 위 사각형",
  "block.minecraft.banner.square_top_right.yellow": "노란색 왼쪽 위 사각형",
  "block.minecraft.banner.straight_cross.black": "검은색 십자",
  "block.minecraft.banner.straight_cross.blue": "파란색 십자",
  "block.minecraft.banner.straight_cross.brown": "갈색 십자",
  "block.minecraft.banner.straight_cross.cyan": "청록색 십자",
  "block.minecraft.banner.straight_cross.gray": "회색 십자",
  "block.minecraft.banner.straight_cross.green": "초록색 십자",
  "block.minecraft.banner.straight_cross.light_blue": "하늘색 십자",
  "block.minecraft.banner.straight_cross.light_gray": "회백색 십자",
  "block.minecraft.banner.straight_cross.lime": "연두색 십자",
  "block.minecraft.banner.straight_cross.magenta": "자홍색 십자",
  "block.minecraft.banner.straight_cross.orange": "주황색 십자",
  "block.minecraft.banner.straight_cross.pink": "분홍색 십자",
  "block.minecraft.banner.straight_cross.purple": "보라색 십자",
  "block.minecraft.banner.straight_cross.red": "빨간색 십자",
  "block.minecraft.banner.straight_cross.white": "하얀색 십자",
  "block.minecraft.banner.straight_cross.yellow": "노란색 십자",
  "block.minecraft.banner.stripe_bottom.black": "검은색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.blue": "파란색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.brown": "갈색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.cyan": "청록색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.gray": "회색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.green": "초록색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.light_blue": "하늘색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.light_gray": "회백색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.lime": "연두색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.magenta": "자홍색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.orange": "주황색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.pink": "분홍색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.purple": "보라색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.red": "빨간색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.white": "하얀색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_bottom.yellow": "노란색 아래쪽 가로띠",
  "block.minecraft.banner.stripe_center.black": "검은색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.blue": "파란색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.brown": "갈색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.cyan": "청록색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.gray": "회색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.green": "초록색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.light_blue": "하늘색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.light_gray": "회백색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.lime": "연두색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.magenta": "자홍색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.orange": "주황색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.pink": "분홍색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.purple": "보라색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.red": "빨간색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.white": "하얀색 중앙 세로띠",
  "block.minecraft.banner.stripe_center.yellow": "노란색 중앙 세로띠",
  "block.minecraft.banner.stripe_downleft.black": "검은색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.blue": "파란색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.brown": "갈색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.cyan": "청록색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.gray": "회색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.green": "초록색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.light_blue": "하늘색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.light_gray": "회백색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.lime": "연두색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.magenta": "자홍색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.orange": "주황색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.pink": "분홍색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.purple": "보라색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.red": "빨간색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.white": "하얀색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downleft.yellow": "노란색 왼쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.black": "검은색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.blue": "파란색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.brown": "갈색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.cyan": "청록색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.gray": "회색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.green": "초록색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.light_blue": "하늘색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.light_gray": "회백색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.lime": "연두색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.magenta": "자홍색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.orange": "주황색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.pink": "분홍색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.purple": "보라색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.red": "빨간색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.white": "하얀색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_downright.yellow": "노란색 오른쪽 위로부터의 사선",
  "block.minecraft.banner.stripe_left.black": "검은색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.blue": "파란색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.brown": "갈색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.cyan": "청록색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.gray": "회색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.green": "초록색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.light_blue": "하늘색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.light_gray": "회백색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.lime": "연두색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.magenta": "자홍색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.orange": "주황색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.pink": "분홍색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.purple": "보라색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.red": "빨간색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.white": "하얀색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_left.yellow": "노란색 오른쪽 세로띠",
  "block.minecraft.banner.stripe_middle.black": "검은색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.blue": "파란색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.brown": "갈색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.cyan": "청록색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.gray": "회색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.green": "초록색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.light_blue": "하늘색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.light_gray": "회백색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.lime": "연두색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.magenta": "자홍색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.orange": "주황색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.pink": "분홍색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.purple": "보라색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.red": "빨간색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.white": "하얀색 중앙 가로띠",
  "block.minecraft.banner.stripe_middle.yellow": "노란색 중앙 가로띠",
  "block.minecraft.banner.stripe_right.black": "검은색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.blue": "파란색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.brown": "갈색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.cyan": "청록색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.gray": "회색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.green": "초록색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.light_blue": "하늘색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.light_gray": "회백색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.lime": "연두색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.magenta": "자홍색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.orange": "주황색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.pink": "분홍색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.purple": "보라색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.red": "빨간색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.white": "하얀색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_right.yellow": "노란색 왼쪽 세로띠",
  "block.minecraft.banner.stripe_top.black": "검은색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.blue": "파란색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.brown": "갈색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.cyan": "청록색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.gray": "회색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.green": "초록색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.light_blue": "하늘색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.light_gray": "회백색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.lime": "연두색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.magenta": "자홍색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.orange": "주황색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.pink": "분홍색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.purple": "보라색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.red": "빨간색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.white": "하얀색 위쪽 가로띠",
  "block.minecraft.banner.stripe_top.yellow": "노란색 위쪽 가로띠",
  "block.minecraft.banner.triangle_bottom.black": "검은색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.blue": "파란색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.brown": "갈색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.cyan": "청록색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.gray": "회색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.green": "초록색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.light_blue": "하늘색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.light_gray": "회백색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.lime": "연두색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.magenta": "자홍색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.orange": "주황색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.pink": "분홍색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.purple": "보라색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.red": "빨간색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.white": "하얀색 하단 삼각형",
  "block.minecraft.banner.triangle_bottom.yellow": "노란색 하단 삼각형",
  "block.minecraft.banner.triangle_top.black": "검은색 상단 삼각형",
  "block.minecraft.banner.triangle_top.blue": "파란색 상단 삼각형",
  "block.minecraft.banner.triangle_top.brown": "갈색 상단 삼각형",
  "block.minecraft.banner.triangle_top.cyan": "청록색 상단 삼각형",
  "block.minecraft.banner.triangle_top.gray": "회색 상단 삼각형",
  "block.minecraft.banner.triangle_top.green": "초록색 상단 삼각형",
  "block.minecraft.banner.triangle_top.light_blue": "하늘색 상단 삼각형",
  "block.minecraft.banner.triangle_top.light_gray": "회백색 상단 삼각형",
  "block.minecraft.banner.triangle_top.lime": "연두색 상단 삼각형",
  "block.minecraft.banner.triangle_top.magenta": "자홍색 상단 삼각형",
  "block.minecraft.banner.triangle_top.orange": "주황색 상단 삼각형",
  "block.minecraft.banner.triangle_top.pink": "분홍색 상단 삼각형",
  "block.minecraft.banner.triangle_top.purple": "보라색 상단 삼각형",
  "block.minecraft.banner.triangle_top.red": "빨간색 상단 삼각형",
  "block.minecraft.banner.triangle_top.white": "하얀색 상단 삼각형",
  "block.minecraft.banner.triangle_top.yellow": "노란색 상단 삼각형",
  "block.minecraft.banner.triangles_bottom.black": "검은색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.blue": "파란색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.brown": "갈색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.cyan": "청록색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.gray": "회색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.green": "초록색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.light_blue": "하늘색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.light_gray": "회백색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.lime": "연두색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.magenta": "자홍색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.orange": "주황색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.pink": "분홍색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.purple": "보라색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.red": "빨간색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.white": "하얀색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_bottom.yellow": "노란색 아래쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.black": "검은색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.blue": "파란색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.brown": "갈색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.cyan": "청록색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.gray": "회색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.green": "초록색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.light_blue": "하늘색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.light_gray": "회백색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.lime": "연두색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.magenta": "자홍색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.orange": "주황색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.pink": "분홍색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.purple": "보라색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.red": "빨간색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.white": "하얀색 위쪽 톱니 모양",
  "block.minecraft.banner.triangles_top.yellow": "노란색 위쪽 톱니 모양",
  "block.minecraft.barrel": "통",
  "block.minecraft.barrier": "방벽",
  "block.minecraft.basalt": "현무암",
  "block.minecraft.beacon": "신호기",
  "block.minecraft.beacon.primary": "주 효과",
  "block.minecraft.beacon.secondary": "보조 효과",
  "block.minecraft.bed.no_sleep": "밤이나 뇌우 중에만 잘 수 있습니다",
  "block.minecraft.bed.not_safe": "근처에 몬스터가 있어 쉴 수 없습니다",
  "block.minecraft.bed.obstructed": "침대가 막혀 있습니다",
  "block.minecraft.bed.occupied": "다른 사람이 이미 침대에 누워 있습니다",
  "block.minecraft.bed.too_far_away": "침대가 너무 멀리 있어 쉴 수 없습니다",
  "block.minecraft.bedrock": "기반암",
  "block.minecraft.bee_nest": "벌집",
  "block.minecraft.beehive": "벌통",
  "block.minecraft.beetroots": "비트",
  "block.minecraft.bell": "종",
  "block.minecraft.big_dripleaf": "큰 흘림잎",
  "block.minecraft.big_dripleaf_stem": "큰 흘림잎 줄기",
  "block.minecraft.birch_button": "자작나무 버튼",
  "block.minecraft.birch_door": "자작나무 문",
  "block.minecraft.birch_fence": "자작나무 울타리",
  "block.minecraft.birch_fence_gate": "자작나무 울타리 문",
  "block.minecraft.birch_hanging_sign": "자작나무 매다는 표지판",
  "block.minecraft.birch_leaves": "자작나무 잎",
  "block.minecraft.birch_log": "자작나무 원목",
  "block.minecraft.birch_planks": "자작나무 판자",
  "block.minecraft.birch_pressure_plate": "자작나무 압력판",
  "block.minecraft.birch_sapling": "자작나무 묘목",
  "block.minecraft.birch_shelf": "자작나무 선반",
  "block.minecraft.birch_sign": "자작나무 표지판",
  "block.minecraft.birch_slab": "자작나무 반 블록",
  "block.minecraft.birch_stairs": "자작나무 계단",
  "block.minecraft.birch_trapdoor": "자작나무 다락문",
  "block.minecraft.birch_wall_hanging_sign": "자작나무 벽 매다는 표지판",
  "block.minecraft.birch_wall_sign": "자작나무 벽 표지판",
  "block.minecraft.birch_wood": "자작나무",
  "block.minecraft.black_banner": "검은색 현수막",
  "block.minecraft.black_bed": "검은색 침대",
  "block.minecraft.black_candle": "검은색 초",
  "block.minecraft.black_candle_cake": "검은색 초를 꽂은 케이크",
  "block.minecraft.black_carpet": "검은색 양탄자",
  "block.minecraft.black_concrete": "검은색 콘크리트",
  "block.minecraft.black_concrete_powder": "검은색 콘크리트 가루",
  "block.minecraft.black_glazed_terracotta": "검은색 유광 테라코타",
  "block.minecraft.black_shulker_box": "검은색 셜커 상자",
  "block.minecraft.black_stained_glass": "검은색 색유리",
  "block.minecraft.black_stained_glass_pane": "검은색 색유리 판",
  "block.minecraft.black_terracotta": "검은색 테라코타",
  "block.minecraft.black_wool": "검은색 양털",
  "block.minecraft.blackstone": "흑암",
  "block.minecraft.blackstone_slab": "흑암 반 블록",
  "block.minecraft.blackstone_stairs": "흑암 계단",
  "block.minecraft.blackstone_wall": "흑암 담장",
  "block.minecraft.blast_furnace": "용광로",
  "block.minecraft.blue_banner": "파란색 현수막",
  "block.minecraft.blue_bed": "파란색 침대",
  "block.minecraft.blue_candle": "파란색 초",
  "block.minecraft.blue_candle_cake": "파란색 초를 꽂은 케이크",
  "block.minecraft.blue_carpet": "파란색 양탄자",
  "block.minecraft.blue_concrete": "파란색 콘크리트",
  "block.minecraft.blue_concrete_powder": "파란색 콘크리트 가루",
  "block.minecraft.blue_glazed_terracotta": "파란색 유광 테라코타",
  "block.minecraft.blue_ice": "푸른얼음",
  "block.minecraft.blue_orchid": "파란색 난초",
  "block.minecraft.blue_shulker_box": "파란색 셜커 상자",
  "block.minecraft.blue_stained_glass": "파란색 색유리",
  "block.minecraft.blue_stained_glass_pane": "파란색 색유리 판",
  "block.minecraft.blue_terracotta": "파란색 테라코타",
  "block.minecraft.blue_wool": "파란색 양털",
  "block.minecraft.bone_block": "뼈 블록",
  "block.minecraft.bookshelf": "책장",
  "block.minecraft.brain_coral": "뇌 산호",
  "block.minecraft.brain_coral_block": "뇌 산호 블록",
  "block.minecraft.brain_coral_fan": "부채형 뇌 산호",
  "block.minecraft.brain_coral_wall_fan": "부채형 뇌 산호 벽",
  "block.minecraft.brewing_stand": "양조기",
  "block.minecraft.brick_slab": "벽돌 반 블록",
  "block.minecraft.brick_stairs": "벽돌 계단",
  "block.minecraft.brick_wall": "벽돌 담장",
  "block.minecraft.bricks": "벽돌",
  "block.minecraft.brown_banner": "갈색 현수막",
  "block.minecraft.brown_bed": "갈색 침대",
  "block.minecraft.brown_candle": "갈색 초",
  "block.minecraft.brown_candle_cake": "갈색 초를 꽂은 케이크",
  "block.minecraft.brown_carpet": "갈색 양탄자",
  "block.minecraft.brown_concrete": "갈색 콘크리트",
  "block.minecraft.brown_concrete_powder": "갈색 콘크리트 가루",
  "block.minecraft.brown_glazed_terracotta": "갈색 유광 테라코타",
  "block.minecraft.brown_mushroom": "갈색 버섯",
  "block.minecraft.brown_mushroom_block": "갈색 버섯 블록",
  "block.minecraft.brown_shulker_box": "갈색 셜커 상자",
  "block.minecraft.brown_stained_glass": "갈색 색유리",
  "block.minecraft.brown_stained_glass_pane": "갈색 색유리 판",
  "block.minecraft.brown_terracotta": "갈색 테라코타",
  "block.minecraft.brown_wool": "갈색 양털",
  "block.minecraft.bubble_column": "거품 기둥",
  "block.minecraft.bubble_coral": "거품 산호",
  "block.minecraft.bubble_coral_block": "거품 산호 블록",
  "block.minecraft.bubble_coral_fan": "부채형 거품 산호",
  "block.minecraft.bubble_coral_wall_fan": "부채형 거품 산호 벽",
  "block.minecraft.budding_amethyst": "싹 틔우는 자수정",
  "block.minecraft.bush": "덤불",
  "block.minecraft.cactus": "선인장",
  "block.minecraft.cactus_flower": "선인장 꽃",
  "block.minecraft.cake": "케이크",
  "block.minecraft.calcite": "방해석",
  "block.minecraft.calibrated_sculk_sensor": "조율한 스컬크 감지체",
  "block.minecraft.campfire": "모닥불",
  "block.minecraft.candle": "초",
  "block.minecraft.candle_cake": "초를 꽂은 케이크",
  "block.minecraft.carrots": "당근",
  "block.minecraft.cartography_table": "지도 제작대",
  "block.minecraft.carved_pumpkin": "조각된 호박",
  "block.minecraft.cauldron": "가마솥",
  "block.minecraft.cave_air": "동굴 공기",
  "block.minecraft.cave_vines": "동굴 덩굴",
  "block.minecraft.cave_vines_plant": "동굴 덩굴 식물",
  "block.minecraft.chain": "사슬",
  "block.minecraft.chain_command_block": "연쇄형 명령 블록",
  "block.minecraft.cherry_button": "벚나무 버튼",
  "block.minecraft.cherry_door": "벚나무 문",
  "block.minecraft.cherry_fence": "벚나무 울타리",
  "block.minecraft.cherry_fence_gate": "벚나무 울타리 문",
  "block.minecraft.cherry_hanging_sign": "벚나무 매다는 표지판",
  "block.minecraft.cherry_leaves": "벚나무 잎",
  "block.minecraft.cherry_log": "벚나무 원목",
  "block.minecraft.cherry_planks": "벚나무 판자",
  "block.minecraft.cherry_pressure_plate": "벚나무 압력판",
  "block.minecraft.cherry_sapling": "벚나무 묘목",
  "block.minecraft.cherry_shelf": "벚나무 선반",
  "block.minecraft.cherry_sign": "벚나무 표지판",
  "block.minecraft.cherry_slab": "벚나무 반 블록",
  "block.minecraft.cherry_stairs": "벚나무 계단",
  "block.minecraft.cherry_trapdoor": "벚나무 다락문",
  "block.minecraft.cherry_wall_hanging_sign": "벚나무 벽 매다는 표지판",
  "block.minecraft.cherry_wall_sign": "벚나무 벽 표지판",
  "block.minecraft.cherry_wood": "벚나무",
  "block.minecraft.chest": "상자",
  "block.minecraft.chipped_anvil": "금 간 모루",
  "block.minecraft.chiseled_bookshelf": "조각된 책장",
  "block.minecraft.chiseled_copper": "조각된 구리",
  "block.minecraft.chiseled_deepslate": "조각된 심층암",
  "block.minecraft.chiseled_nether_bricks": "조각된 네더 벽돌",
  "block.minecraft.chiseled_polished_blackstone": "조각된 윤나는 흑암",
  "block.minecraft.chiseled_quartz_block": "조각된 석영 블록",
  "block.minecraft.chiseled_red_sandstone": "조각된 붉은 사암",
  "block.minecraft.chiseled_resin_bricks": "조각된 수지 벽돌",
  "block.minecraft.chiseled_sandstone": "조각된 사암",
  "block.minecraft.chiseled_stone_bricks": "조각된 석재 벽돌",
  "block.minecraft.chiseled_tuff": "조각된 응회암",
  "block.minecraft.chiseled_tuff_bricks": "조각된 응회암 벽돌",
  "block.minecraft.chorus_flower": "후렴화",
  "block.minecraft.chorus_plant": "후렴초",
  "block.minecraft.clay": "점토",
  "block.minecraft.closed_eyeblossom": "감은 눈망울꽃",
  "block.minecraft.coal_block": "석탄 블록",
  "block.minecraft.coal_ore": "석탄 광석",
  "block.minecraft.coarse_dirt": "거친 흙",
  "block.minecraft.cobbled_deepslate": "심층암 조약돌",
  "block.minecraft.cobbled_deepslate_slab": "심층암 조약돌 반 블록",
  "block.minecraft.cobbled_deepslate_stairs": "심층암 조약돌 계단",
  "block.minecraft.cobbled_deepslate_wall": "심층암 조약돌 담장",
  "block.minecraft.cobblestone": "조약돌",
  "block.minecraft.cobblestone_slab": "조약돌 반 블록",
  "block.minecraft.cobblestone_stairs": "조약돌 계단",
  "block.minecraft.cobblestone_wall": "조약돌 담장",
  "block.minecraft.cobweb": "거미줄",
  "block.minecraft.cocoa": "코코아",
  "block.minecraft.command_block": "명령 블록",
  "block.minecraft.comparator": "레드스톤 비교기",
  "block.minecraft.composter": "퇴비통",
  "block.minecraft.conduit": "전달체",
  "block.minecraft.copper_bars": "구리 창살",
  "block.minecraft.copper_block": "구리 블록",
  "block.minecraft.copper_bulb": "구리 전구",
  "block.minecraft.copper_chain": "구리 사슬",
  "block.minecraft.copper_chest": "구리 상자",
  "block.minecraft.copper_door": "구리 문",
  "block.minecraft.copper_golem_statue": "구리 골렘 동상",
  "block.minecraft.copper_grate": "구리 격자",
  "block.minecraft.copper_lantern": "구리 랜턴",
  "block.minecraft.copper_ore": "구리 광석",
  "block.minecraft.copper_torch": "구리 횃불",
  "block.minecraft.copper_trapdoor": "구리 다락문",
  "block.minecraft.copper_wall_torch": "구리 벽 횃불",
  "block.minecraft.cornflower": "수레국화",
  "block.minecraft.cracked_deepslate_bricks": "금 간 심층암 벽돌",
  "block.minecraft.cracked_deepslate_tiles": "금 간 심층암 타일",
  "block.minecraft.cracked_nether_bricks": "금 간 네더 벽돌",
  "block.minecraft.cracked_polished_blackstone_bricks": "금 간 윤나는 흑암 벽돌",
  "block.minecraft.cracked_stone_bricks": "금 간 석재 벽돌",
  "block.minecraft.crafter": "제작기",
  "block.minecraft.crafting_table": "제작대",
  "block.minecraft.creaking_heart": "크리킹 심장",
  "block.minecraft.creeper_head": "크리퍼 머리",
  "block.minecraft.creeper_wall_head": "크리퍼 벽 머리",
  "block.minecraft.crimson_button": "진홍빛 버튼",
  "block.minecraft.crimson_door": "진홍빛 문",
  "block.minecraft.crimson_fence": "진홍빛 울타리",
  "block.minecraft.crimson_fence_gate": "진홍빛 울타리 문",
  "block.minecraft.crimson_fungus": "진홍빛 균",
  "block.minecraft.crimson_hanging_sign": "진홍빛 매다는 표지판",
  "block.minecraft.crimson_hyphae": "진홍빛 균사",
  "block.minecraft.crimson_nylium": "진홍빛 네사체",
  "block.minecraft.crimson_planks": "진홍빛 판자",
  "block.minecraft.crimson_pressure_plate": "진홍빛 압력판",
  "block.minecraft.crimson_roots": "진홍빛 뿌리",
  "block.minecraft.crimson_shelf": "진홍빛 선반",
  "block.minecraft.crimson_sign": "진홍빛 표지판",
  "block.minecraft.crimson_slab": "진홍빛 반 블록",
  "block.minecraft.crimson_stairs": "진홍빛 계단",
  "block.minecraft.crimson_stem": "진홍빛 자루",
  "block.minecraft.crimson_trapdoor": "진홍빛 다락문",
  "block.minecraft.crimson_wall_hanging_sign": "진홍빛 벽 매다는 표지판",
  "block.minecraft.crimson_wall_sign": "진홍빛 벽 표지판",
  "block.minecraft.crying_obsidian": "우는 흑요석",
  "block.minecraft.cut_copper": "깎인 구리",
  "block.minecraft.cut_copper_slab": "깎인 구리 반 블록",
  "block.minecraft.cut_copper_stairs": "깎인 구리 계단",
  "block.minecraft.cut_red_sandstone": "깎인 붉은 사암",
  "block.minecraft.cut_red_sandstone_slab": "깎인 붉은 사암 반 블록",
  "block.minecraft.cut_sandstone": "깎인 사암",
  "block.minecraft.cut_sandstone_slab": "깎인 사암 반 블록",
  "block.minecraft.cyan_banner": "청록색 현수막",
  "block.minecraft.cyan_bed": "청록색 침대",
  "block.minecraft.cyan_candle": "청록색 초",
  "block.minecraft.cyan_candle_cake": "청록색 초를 꽂은 케이크",
  "block.minecraft.cyan_carpet": "청록색 양탄자",
  "block.minecraft.cyan_concrete": "청록색 콘크리트",
  "block.minecraft.cyan_concrete_powder": "청록색 콘크리트 가루",
  "block.minecraft.cyan_glazed_terracotta": "청록색 유광 테라코타",
  "block.minecraft.cyan_shulker_box": "청록색 셜커 상자",
  "block.minecraft.cyan_stained_glass": "청록색 색유리",
  "block.minecraft.cyan_stained_glass_pane": "청록색 색유리 판",
  "block.minecraft.cyan_terracotta": "청록색 테라코타",
  "block.minecraft.cyan_wool": "청록색 양털",
  "block.minecraft.damaged_anvil": "손상된 모루",
  "block.minecraft.dandelion": "민들레",
  "block.minecraft.dark_oak_button": "짙은 참나무 버튼",
  "block.minecraft.dark_oak_door": "짙은 참나무 문",
  "block.minecraft.dark_oak_fence": "짙은 참나무 울타리",
  "block.minecraft.dark_oak_fence_gate": "짙은 참나무 울타리 문",
  "block.minecraft.dark_oak_hanging_sign": "짙은 참나무 매다는 표지판",
  "block.minecraft.dark_oak_leaves": "짙은 참나무 잎",
  "block.minecraft.dark_oak_log": "짙은 참나무 원목",
  "block.minecraft.dark_oak_planks": "짙은 참나무 판자",
  "block.minecraft.dark_oak_pressure_plate": "짙은 참나무 압력판",
  "block.minecraft.dark_oak_sapling": "짙은 참나무 묘목",
  "block.minecraft.dark_oak_shelf": "짙은 참나무 선반",
  "block.minecraft.dark_oak_sign": "짙은 참나무 표지판",
  "block.minecraft.dark_oak_slab": "짙은 참나무 반 블록",
  "block.minecraft.dark_oak_stairs": "짙은 참나무 계단",
  "block.minecraft.dark_oak_trapdoor": "짙은 참나무 다락문",
  "block.minecraft.dark_oak_wall_hanging_sign": "짙은 참나무 벽 매다는 표지판",
  "block.minecraft.dark_oak_wall_sign": "짙은 참나무 벽 표지판",
  "block.minecraft.dark_oak_wood": "짙은 참나무",
  "block.minecraft.dark_prismarine": "짙은 프리즈머린",
  "block.minecraft.dark_prismarine_slab": "짙은 프리즈머린 반 블록",
  "block.minecraft.dark_prismarine_stairs": "짙은 프리즈머린 계단",
  "block.minecraft.daylight_detector": "햇빛 감지기",
  "block.minecraft.dead_brain_coral": "죽은 뇌 산호",
  "block.minecraft.dead_brain_coral_block": "죽은 뇌 산호 블록",
  "block.minecraft.dead_brain_coral_fan": "죽은 부채형 뇌 산호",
  "block.minecraft.dead_brain_coral_wall_fan": "죽은 부채형 뇌 산호 벽",
  "block.minecraft.dead_bubble_coral": "죽은 거품 산호",
  "block.minecraft.dead_bubble_coral_block": "죽은 거품 산호 블록",
  "block.minecraft.dead_bubble_coral_fan": "죽은 부채형 거품 산호",
  "block.minecraft.dead_bubble_coral_wall_fan": "죽은 부채형 거품 산호 벽",
  "block.minecraft.dead_bush": "마른 덤불",
  "block.minecraft.dead_fire_coral": "죽은 불 산호",
  "block.minecraft.dead_fire_coral_block": "죽은 불 산호 블록",
  "block.minecraft.dead_fire_coral_fan": "죽은 부채형 불 산호",
  "block.minecraft.dead_fire_coral_wall_fan": "죽은 부채형 불 산호 벽",
  "block.minecraft.dead_horn_coral": "죽은 사방산호",
  "block.minecraft.dead_horn_coral_block": "죽은 사방산호 블록",
  "block.minecraft.dead_horn_coral_fan": "죽은 부채형 사방산호",
  "block.minecraft.dead_horn_coral_wall_fan": "죽은 부채형 사방산호 벽",
  "block.minecraft.dead_tube_coral": "죽은 관 산호",
  "block.minecraft.dead_tube_coral_block": "죽은 관 산호 블록",
  "block.minecraft.dead_tube_coral_fan": "죽은 부채형 관 산호",
  "block.minecraft.dead_tube_coral_wall_fan": "죽은 부채형 관 산호 벽",
  "block.minecraft.decorated_pot": "장식된 도자기",
  "block.minecraft.deepslate": "심층암",
  "block.minecraft.deepslate_brick_slab": "심층암 벽돌 반 블록",
  "block.minecraft.deepslate_brick_stairs": "심층암 벽돌 계단",
  "block.minecraft.deepslate_brick_wall": "심층암 벽돌 담장",
  "block.minecraft.deepslate_bricks": "심층암 벽돌",
  "block.minecraft.deepslate_coal_ore": "심층암 석탄 광석",
  "block.minecraft.deepslate_copper_ore": "심층암 구리 광석",
  "block.minecraft.deepslate_diamond_ore": "심층암 다이아몬드 광석",
  "block.minecraft.deepslate_emerald_ore": "심층암 에메랄드 광석",
  "block.minecraft.deepslate_gold_ore": "심층암 금 광석",
  "block.minecraft.deepslate_iron_ore": "심층암 철 광석",
  "block.minecraft.deepslate_lapis_ore": "심층암 청금석 광석",
  "block.minecraft.deepslate_redstone_ore": "심층암 레드스톤 광석",
  "block.minecraft.deepslate_tile_slab": "심층암 타일 반 블록",
  "block.minecraft.deepslate_tile_stairs": "심층암 타일 계단",
  "block.minecraft.deepslate_tile_wall": "심층암 타일 담장",
  "block.minecraft.deepslate_tiles": "심층암 타일",
  "block.minecraft.detector_rail": "감지 레일",
  "block.minecraft.diamond_block": "다이아몬드 블록",
  "block.minecraft.diamond_ore": "다이아몬드 광석",
  "block.minecraft.diorite": "섬록암",
  "block.minecraft.diorite_slab": "섬록암 반 블록",
  "block.minecraft.diorite_stairs": "섬록암 계단",
  "block.minecraft.diorite_wall": "섬록암 담장",
  "block.minecraft.dirt": "흙",
  "block.minecraft.dirt_path": "흙 길",
  "block.minecraft.dispenser": "발사기",
  "block.minecraft.dragon_egg": "드래곤 알",
  "block.minecraft.dragon_head": "드래곤 머리",
  "block.minecraft.dragon_wall_head": "드래곤 벽 머리",
  "block.minecraft.dried_ghast": "마른 가스트",
  "block.minecraft.dried_kelp_block": "말린 켈프 블록",
  "block.minecraft.dripstone_block": "점적석 블록",
  "block.minecraft.dropper": "공급기",
  "block.minecraft.emerald_block": "에메랄드 블록",
  "block.minecraft.emerald_ore": "에메랄드 광석",
  "block.minecraft.enchanting_table": "마법 부여대",
  "block.minecraft.end_gateway": "엔드 관문",
  "block.minecraft.end_portal": "엔드 차원문",
  "block.minecraft.end_portal_frame": "엔드 차원문 틀",
  "block.minecraft.end_rod": "엔드 막대기",
  "block.minecraft.end_stone": "엔드 돌",
  "block.minecraft.end_stone_brick_slab": "엔드 석재 벽돌 반 블록",
  "block.minecraft.end_stone_brick_stairs": "엔드 석재 벽돌 계단",
  "block.minecraft.end_stone_brick_wall": "엔드 석재 벽돌 담장",
  "block.minecraft.end_stone_bricks": "엔드 석재 벽돌",
  "block.minecraft.ender_chest": "엔더 상자",
  "block.minecraft.exposed_chiseled_copper": "약간 녹슨 조각된 구리",
  "block.minecraft.exposed_copper": "약간 녹슨 구리",
  "block.minecraft.exposed_copper_bars": "약간 녹슨 구리 창살",
  "block.minecraft.exposed_copper_bulb": "약간 녹슨 구리 전구",
  "block.minecraft.exposed_copper_chain": "약간 녹슨 구리 사슬",
  "block.minecraft.exposed_copper_chest": "약간 녹슨 구리 상자",
  "block.minecraft.exposed_copper_door": "약간 녹슨 구리 문",
  "block.minecraft.exposed_copper_golem_statue": "약간 녹슨 구리 골렘 동상",
  "block.minecraft.exposed_copper_grate": "약간 녹슨 구리 격자",
  "block.minecraft.exposed_copper_lantern": "약간 녹슨 구리 랜턴",
  "block.minecraft.exposed_copper_trapdoor": "약간 녹슨 구리 다락문",
  "block.minecraft.exposed_cut_copper": "약간 녹슨 깎인 구리",
  "block.minecraft.exposed_cut_copper_slab": "약간 녹슨 깎인 구리 반 블록",
  "block.minecraft.exposed_cut_copper_stairs": "약간 녹슨 깎인 구리 계단",
  "block.minecraft.exposed_lightning_rod": "약간 녹슨 피뢰침",
  "block.minecraft.farmland": "경작지",
  "block.minecraft.fern": "고사리",
  "block.minecraft.fire": "불",
  "block.minecraft.fire_coral": "불 산호",
  "block.minecraft.fire_coral_block": "불 산호 블록",
  "block.minecraft.fire_coral_fan": "부채형 불 산호",
  "block.minecraft.fire_coral_wall_fan": "부채형 불 산호 벽",
  "block.minecraft.firefly_bush": "반딧불이 덤불",
  "block.minecraft.fletching_table": "화살 작업대",
  "block.minecraft.flower_pot": "화분",
  "block.minecraft.flowering_azalea": "꽃 핀 진달래",
  "block.minecraft.flowering_azalea_leaves": "꽃 핀 진달래 잎",
  "block.minecraft.frogspawn": "개구리알",
  "block.minecraft.frosted_ice": "살얼음",
  "block.minecraft.furnace": "화로",
  "block.minecraft.gilded_blackstone": "황금이 박힌 흑암",
  "block.minecraft.glass": "유리",
  "block.minecraft.glass_pane": "유리판",
  "block.minecraft.glow_lichen": "발광 이끼",
  "block.minecraft.glowstone": "발광석",
  "block.minecraft.gold_block": "금 블록",
  "block.minecraft.gold_ore": "금 광석",
  "block.minecraft.golden_dandelion": "황금 민들레",
  "block.minecraft.granite": "화강암",
  "block.minecraft.granite_slab": "화강암 반 블록",
  "block.minecraft.granite_stairs": "화강암 계단",
  "block.minecraft.granite_wall": "화강암 담장",
  "block.minecraft.grass": "잔디",
  "block.minecraft.grass_block": "잔디 블록",
  "block.minecraft.gravel": "자갈",
  "block.minecraft.gray_banner": "회색 현수막",
  "block.minecraft.gray_bed": "회색 침대",
  "block.minecraft.gray_candle": "회색 초",
  "block.minecraft.gray_candle_cake": "회색 초를 꽂은 케이크",
  "block.minecraft.gray_carpet": "회색 양탄자",
  "block.minecraft.gray_concrete": "회색 콘크리트",
  "block.minecraft.gray_concrete_powder": "회색 콘크리트 가루",
  "block.minecraft.gray_glazed_terracotta": "회색 유광 테라코타",
  "block.minecraft.gray_shulker_box": "회색 셜커 상자",
  "block.minecraft.gray_stained_glass": "회색 색유리",
  "block.minecraft.gray_stained_glass_pane": "회색 색유리 판",
  "block.minecraft.gray_terracotta": "회색 테라코타",
  "block.minecraft.gray_wool": "회색 양털",
  "block.minecraft.green_banner": "초록색 현수막",
  "block.minecraft.green_bed": "초록색 침대",
  "block.minecraft.green_candle": "초록색 초",
  "block.minecraft.green_candle_cake": "초록색 초를 꽂은 케이크",
  "block.minecraft.green_carpet": "초록색 양탄자",
  "block.minecraft.green_concrete": "초록색 콘크리트",
  "block.minecraft.green_concrete_powder": "초록색 콘크리트 가루",
  "block.minecraft.green_glazed_terracotta": "초록색 유광 테라코타",
  "block.minecraft.green_shulker_box": "초록색 셜커 상자",
  "block.minecraft.green_stained_glass": "초록색 색유리",
  "block.minecraft.green_stained_glass_pane": "초록색 색유리 판",
  "block.minecraft.green_terracotta": "초록색 테라코타",
  "block.minecraft.green_wool": "초록색 양털",
  "block.minecraft.grindstone": "숫돌",
  "block.minecraft.hanging_roots": "매달린 뿌리",
  "block.minecraft.hay_block": "건초 더미",
  "block.minecraft.heavy_core": "무거운 코어",
  "block.minecraft.heavy_weighted_pressure_plate": "중형 무게 압력판",
  "block.minecraft.honey_block": "꿀 블록",
  "block.minecraft.honeycomb_block": "벌집 조각 블록",
  "block.minecraft.hopper": "호퍼",
  "block.minecraft.horn_coral": "사방산호",
  "block.minecraft.horn_coral_block": "사방산호 블록",
  "block.minecraft.horn_coral_fan": "부채형 사방산호",
  "block.minecraft.horn_coral_wall_fan": "부채형 사방산호 벽",
  "block.minecraft.ice": "얼음",
  "block.minecraft.infested_chiseled_stone_bricks": "벌레 먹은 조각된 석재 벽돌",
  "block.minecraft.infested_cobblestone": "벌레 먹은 조약돌",
  "block.minecraft.infested_cracked_stone_bricks": "벌레 먹은 금 간 석재 벽돌",
  "block.minecraft.infested_deepslate": "벌레 먹은 심층암",
  "block.minecraft.infested_mossy_stone_bricks": "벌레 먹은 이끼 낀 석재 벽돌",
  "block.minecraft.infested_stone": "벌레 먹은 돌",
  "block.minecraft.infested_stone_bricks": "벌레 먹은 석재 벽돌",
  "block.minecraft.iron_bars": "철 창살",
  "block.minecraft.iron_block": "철 블록",
  "block.minecraft.iron_chain": "철 사슬",
  "block.minecraft.iron_door": "철 문",
  "block.minecraft.iron_ore": "철 광석",
  "block.minecraft.iron_trapdoor": "철 다락문",
  "block.minecraft.jack_o_lantern": "잭오랜턴",
  "block.minecraft.jigsaw": "직소 블록",
  "block.minecraft.jukebox": "주크박스",
  "block.minecraft.jungle_button": "정글나무 버튼",
  "block.minecraft.jungle_door": "정글나무 문",
  "block.minecraft.jungle_fence": "정글나무 울타리",
  "block.minecraft.jungle_fence_gate": "정글나무 울타리 문",
  "block.minecraft.jungle_hanging_sign": "정글나무 매다는 표지판",
  "block.minecraft.jungle_leaves": "정글나무 잎",
  "block.minecraft.jungle_log": "정글나무 원목",
  "block.minecraft.jungle_planks": "정글나무 판자",
  "block.minecraft.jungle_pressure_plate": "정글나무 압력판",
  "block.minecraft.jungle_sapling": "정글나무 묘목",
  "block.minecraft.jungle_shelf": "정글나무 선반",
  "block.minecraft.jungle_sign": "정글나무 표지판",
  "block.minecraft.jungle_slab": "정글나무 반 블록",
  "block.minecraft.jungle_stairs": "정글나무 계단",
  "block.minecraft.jungle_trapdoor": "정글나무 다락문",
  "block.minecraft.jungle_wall_hanging_sign": "정글나무 벽 매다는 표지판",
  "block.minecraft.jungle_wall_sign": "정글나무 벽 표지판",
  "block.minecraft.jungle_wood": "정글나무",
  "block.minecraft.kelp": "켈프",
  "block.minecraft.kelp_plant": "켈프 식물",
  "block.minecraft.ladder": "사다리",
  "block.minecraft.lantern": "랜턴",
  "block.minecraft.lapis_block": "청금석 블록",
  "block.minecraft.lapis_ore": "청금석 광석",
  "block.minecraft.large_amethyst_bud": "큰 자수정 봉오리",
  "block.minecraft.large_fern": "큰 고사리",
  "block.minecraft.lava": "용암",
  "block.minecraft.lava_cauldron": "용암 가마솥",
  "block.minecraft.leaf_litter": "낙엽",
  "block.minecraft.lectern": "독서대",
  "block.minecraft.lever": "레버",
  "block.minecraft.light": "빛",
  "block.minecraft.light_blue_banner": "하늘색 현수막",
  "block.minecraft.light_blue_bed": "하늘색 침대",
  "block.minecraft.light_blue_candle": "하늘색 초",
  "block.minecraft.light_blue_candle_cake": "하늘색 초를 꽂은 케이크",
  "block.minecraft.light_blue_carpet": "하늘색 양탄자",
  "block.minecraft.light_blue_concrete": "하늘색 콘크리트",
  "block.minecraft.light_blue_concrete_powder": "하늘색 콘크리트 가루",
  "block.minecraft.light_blue_glazed_terracotta": "하늘색 유광 테라코타",
  "block.minecraft.light_blue_shulker_box": "하늘색 셜커 상자",
  "block.minecraft.light_blue_stained_glass": "하늘색 색유리",
  "block.minecraft.light_blue_stained_glass_pane": "하늘색 색유리 판",
  "block.minecraft.light_blue_terracotta": "하늘색 테라코타",
  "block.minecraft.light_blue_wool": "하늘색 양털",
  "block.minecraft.light_gray_banner": "회백색 현수막",
  "block.minecraft.light_gray_bed": "회백색 침대",
  "block.minecraft.light_gray_candle": "회백색 초",
  "block.minecraft.light_gray_candle_cake": "회백색 초를 꽂은 케이크",
  "block.minecraft.light_gray_carpet": "회백색 양탄자",
  "block.minecraft.light_gray_concrete": "회백색 콘크리트",
  "block.minecraft.light_gray_concrete_powder": "회백색 콘크리트 가루",
  "block.minecraft.light_gray_glazed_terracotta": "회백색 유광 테라코타",
  "block.minecraft.light_gray_shulker_box": "회백색 셜커 상자",
  "block.minecraft.light_gray_stained_glass": "회백색 색유리",
  "block.minecraft.light_gray_stained_glass_pane": "회백색 색유리 판",
  "block.minecraft.light_gray_terracotta": "회백색 테라코타",
  "block.minecraft.light_gray_wool": "회백색 양털",
  "block.minecraft.light_weighted_pressure_plate": "경형 무게 압력판",
  "block.minecraft.lightning_rod": "피뢰침",
  "block.minecraft.lilac": "라일락",
  "block.minecraft.lily_of_the_valley": "은방울꽃",
  "block.minecraft.lily_pad": "수련잎",
  "block.minecraft.lime_banner": "연두색 현수막",
  "block.minecraft.lime_bed": "연두색 침대",
  "block.minecraft.lime_candle": "연두색 초",
  "block.minecraft.lime_candle_cake": "연두색 초를 꽂은 케이크",
  "block.minecraft.lime_carpet": "연두색 양탄자",
  "block.minecraft.lime_concrete": "연두색 콘크리트",
  "block.minecraft.lime_concrete_powder": "연두색 콘크리트 가루",
  "block.minecraft.lime_glazed_terracotta": "연두색 유광 테라코타",
  "block.minecraft.lime_shulker_box": "연두색 셜커 상자",
  "block.minecraft.lime_stained_glass": "연두색 색유리",
  "block.minecraft.lime_stained_glass_pane": "연두색 색유리 판",
  "block.minecraft.lime_terracotta": "연두색 테라코타",
  "block.minecraft.lime_wool": "연두색 양털",
  "block.minecraft.lodestone": "자석석",
  "block.minecraft.loom": "베틀",
  "block.minecraft.magenta_banner": "자홍색 현수막",
  "block.minecraft.magenta_bed": "자홍색 침대",
  "block.minecraft.magenta_candle": "자홍색 초",
  "block.minecraft.magenta_candle_cake": "자홍색 초를 꽂은 케이크",
  "block.minecraft.magenta_carpet": "자홍색 양탄자",
  "block.minecraft.magenta_concrete": "자홍색 콘크리트",
  "block.minecraft.magenta_concrete_powder": "자홍색 콘크리트 가루",
  "block.minecraft.magenta_glazed_terracotta": "자홍색 유광 테라코타",
  "block.minecraft.magenta_shulker_box": "자홍색 셜커 상자",
  "block.minecraft.magenta_stained_glass": "자홍색 색유리",
  "block.minecraft.magenta_stained_glass_pane": "자홍색 색유리 판",
  "block.minecraft.magenta_terracotta": "자홍색 테라코타",
  "block.minecraft.magenta_wool": "자홍색 양털",
  "block.minecraft.magma_block": "마그마 블록",
  "block.minecraft.mangrove_button": "맹그로브나무 버튼",
  "block.minecraft.mangrove_door": "맹그로브나무 문",
  "block.minecraft.mangrove_fence": "맹그로브나무 울타리",
  "block.minecraft.mangrove_fence_gate": "맹그로브나무 울타리 문",
  "block.minecraft.mangrove_hanging_sign": "맹그로브나무 매다는 표지판",
  "block.minecraft.mangrove_leaves": "맹그로브나무 잎",
  "block.minecraft.mangrove_log": "맹그로브나무 원목",
  "block.minecraft.mangrove_planks": "맹그로브나무 판자",
  "block.minecraft.mangrove_pressure_plate": "맹그로브나무 압력판",
  "block.minecraft.mangrove_propagule": "맹그로브나무 주아",
  "block.minecraft.mangrove_roots": "맹그로브나무 뿌리",
  "block.minecraft.mangrove_shelf": "맹그로브나무 선반",
  "block.minecraft.mangrove_sign": "맹그로브나무 표지판",
  "block.minecraft.mangrove_slab": "맹그로브나무 반 블록",
  "block.minecraft.mangrove_stairs": "맹그로브나무 계단",
  "block.minecraft.mangrove_trapdoor": "맹그로브나무 다락문",
  "block.minecraft.mangrove_wall_hanging_sign": "맹그로브나무 벽 매다는 표지판",
  "block.minecraft.mangrove_wall_sign": "맹그로브나무 벽 표지판",
  "block.minecraft.mangrove_wood": "맹그로브나무",
  "block.minecraft.medium_amethyst_bud": "중간 자수정 봉오리",
  "block.minecraft.melon": "수박",
  "block.minecraft.melon_stem": "수박 줄기",
  "block.minecraft.moss_block": "이끼 블록",
  "block.minecraft.moss_carpet": "이끼 바닥",
  "block.minecraft.mossy_cobblestone": "이끼 낀 조약돌",
  "block.minecraft.mossy_cobblestone_slab": "이끼 낀 조약돌 반 블록",
  "block.minecraft.mossy_cobblestone_stairs": "이끼 낀 조약돌 계단",
  "block.minecraft.mossy_cobblestone_wall": "이끼 낀 조약돌 담장",
  "block.minecraft.mossy_stone_brick_slab": "이끼 낀 석재 벽돌 반 블록",
  "block.minecraft.mossy_stone_brick_stairs": "이끼 낀 석재 벽돌 계단",
  "block.minecraft.mossy_stone_brick_wall": "이끼 낀 석재 벽돌 담장",
  "block.minecraft.mossy_stone_bricks": "이끼 낀 석재 벽돌",
  "block.minecraft.moving_piston": "움직이는 피스톤",
  "block.minecraft.mud": "진흙",
  "block.minecraft.mud_brick_slab": "진흙 벽돌 반 블록",
  "block.minecraft.mud_brick_stairs": "진흙 벽돌 계단",
  "block.minecraft.mud_brick_wall": "진흙 벽돌 담장",
  "block.minecraft.mud_bricks": "진흙 벽돌",
  "block.minecraft.muddy_mangrove_roots": "진흙에 묻힌 맹그로브나무 뿌리",
  "block.minecraft.mushroom_stem": "버섯 자루",
  "block.minecraft.mycelium": "균사체",
  "block.minecraft.nether_brick_fence": "네더 벽돌 울타리",
  "block.minecraft.nether_brick_slab": "네더 벽돌 반 블록",
  "block.minecraft.nether_brick_stairs": "네더 벽돌 계단",
  "block.minecraft.nether_brick_wall": "네더 벽돌 담장",
  "block.minecraft.nether_bricks": "네더 벽돌",
  "block.minecraft.nether_gold_ore": "네더 금 광석",
  "block.minecraft.nether_portal": "네더 차원문",
  "block.minecraft.nether_quartz_ore": "네더 석영 광석",
  "block.minecraft.nether_sprouts": "네더 싹",
  "block.minecraft.nether_wart": "네더 사마귀",
  "block.minecraft.nether_wart_block": "네더 사마귀 블록",
  "block.minecraft.netherite_block": "네더라이트 블록",
  "block.minecraft.netherrack": "네더랙",
  "block.minecraft.note_block": "소리 블록",
  "block.minecraft.oak_button": "참나무 버튼",
  "block.minecraft.oak_door": "참나무 문",
  "block.minecraft.oak_fence": "참나무 울타리",
  "block.minecraft.oak_fence_gate": "참나무 울타리 문",
  "block.minecraft.oak_hanging_sign": "참나무 매다는 표지판",
  "block.minecraft.oak_leaves": "참나무 잎",
  "block.minecraft.oak_log": "참나무 원목",
  "block.minecraft.oak_planks": "참나무 판자",
  "block.minecraft.oak_pressure_plate": "참나무 압력판",
  "block.minecraft.oak_sapling": "참나무 묘목",
  "block.minecraft.oak_shelf": "참나무 선반",
  "block.minecraft.oak_sign": "참나무 표지판",
  "block.minecraft.oak_slab": "참나무 반 블록",
  "block.minecraft.oak_stairs": "참나무 계단",
  "block.minecraft.oak_trapdoor": "참나무 다락문",
  "block.minecraft.oak_wall_hanging_sign": "참나무 벽 매다는 표지판",
  "block.minecraft.oak_wall_sign": "참나무 벽 표지판",
  "block.minecraft.oak_wood": "참나무",
  "block.minecraft.observer": "관측기",
  "block.minecraft.obsidian": "흑요석",
  "block.minecraft.ochre_froglight": "황톳빛 개구리불",
  "block.minecraft.ominous_banner": "불길한 현수막",
  "block.minecraft.open_eyeblossom": "뜬 눈망울꽃",
  "block.minecraft.orange_banner": "주황색 현수막",
  "block.minecraft.orange_bed": "주황색 침대",
  "block.minecraft.orange_candle": "주황색 초",
  "block.minecraft.orange_candle_cake": "주황색 초를 꽂은 케이크",
  "block.minecraft.orange_carpet": "주황색 양탄자",
  "block.minecraft.orange_concrete": "주황색 콘크리트",
  "block.minecraft.orange_concrete_powder": "주황색 콘크리트 가루",
  "block.minecraft.orange_glazed_terracotta": "주황색 유광 테라코타",
  "block.minecraft.orange_shulker_box": "주황색 셜커 상자",
  "block.minecraft.orange_stained_glass": "주황색 색유리",
  "block.minecraft.orange_stained_glass_pane": "주황색 색유리 판",
  "block.minecraft.orange_terracotta": "주황색 테라코타",
  "block.minecraft.orange_tulip": "주황색 튤립",
  "block.minecraft.orange_wool": "주황색 양털",
  "block.minecraft.oxeye_daisy": "데이지",
  "block.minecraft.oxidized_chiseled_copper": "산화된 조각된 구리",
  "block.minecraft.oxidized_copper": "산화된 구리",
  "block.minecraft.oxidized_copper_bars": "산화된 구리 창살",
  "block.minecraft.oxidized_copper_bulb": "산화된 구리 전구",
  "block.minecraft.oxidized_copper_chain": "산화된 구리 사슬",
  "block.minecraft.oxidized_copper_chest": "산화된 구리 상자",
  "block.minecraft.oxidized_copper_door": "산화된 구리 문",
  "block.minecraft.oxidized_copper_golem_statue": "산화된 구리 골렘 동상",
  "block.minecraft.oxidized_copper_grate": "산화된 구리 격자",
  "block.minecraft.oxidized_copper_lantern": "산화된 구리 랜턴",
  "block.minecraft.oxidized_copper_trapdoor": "산화된 구리 다락문",
  "block.minecraft.oxidized_cut_copper": "산화된 깎인 구리",
  "block.minecraft.oxidized_cut_copper_slab": "산화된 깎인 구리 반 블록",
  "block.minecraft.oxidized_cut_copper_stairs": "산화된 깎인 구리 계단",
  "block.minecraft.oxidized_lightning_rod": "산화된 피뢰침",
  "block.minecraft.packed_ice": "꽁꽁 언 얼음",
  "block.minecraft.packed_mud": "단단한 진흙",
  "block.minecraft.pale_hanging_moss": "창백한 매달린 이끼",
  "block.minecraft.pale_moss_block": "창백한 이끼 블록",
  "block.minecraft.pale_moss_carpet": "창백한 이끼 바닥",
  "block.minecraft.pale_oak_button": "창백한 참나무 버튼",
  "block.minecraft.pale_oak_door": "창백한 참나무 문",
  "block.minecraft.pale_oak_fence": "창백한 참나무 울타리",
  "block.minecraft.pale_oak_fence_gate": "창백한 참나무 울타리 문",
  "block.minecraft.pale_oak_hanging_sign": "창백한 참나무 매다는 표지판",
  "block.minecraft.pale_oak_leaves": "창백한 참나무 잎",
  "block.minecraft.pale_oak_log": "창백한 참나무 원목",
  "block.minecraft.pale_oak_planks": "창백한 참나무 판자",
  "block.minecraft.pale_oak_pressure_plate": "창백한 참나무 압력판",
  "block.minecraft.pale_oak_sapling": "창백한 참나무 묘목",
  "block.minecraft.pale_oak_shelf": "창백한 참나무 선반",
  "block.minecraft.pale_oak_sign": "창백한 참나무 표지판",
  "block.minecraft.pale_oak_slab": "창백한 참나무 반 블록",
  "block.minecraft.pale_oak_stairs": "창백한 참나무 계단",
  "block.minecraft.pale_oak_trapdoor": "창백한 참나무 다락문",
  "block.minecraft.pale_oak_wall_hanging_sign": "창백한 참나무 벽 매다는 표지판",
  "block.minecraft.pale_oak_wall_sign": "창백한 참나무 벽 표지판",
  "block.minecraft.pale_oak_wood": "창백한 참나무",
  "block.minecraft.pearlescent_froglight": "진줏빛 개구리불",
  "block.minecraft.peony": "모란",
  "block.minecraft.petrified_oak_slab": "규화한 참나무 반 블록",
  "block.minecraft.piglin_head": "피글린 머리",
  "block.minecraft.piglin_wall_head": "피글린 벽 머리",
  "block.minecraft.pink_banner": "분홍색 현수막",
  "block.minecraft.pink_bed": "분홍색 침대",
  "block.minecraft.pink_candle": "분홍색 초",
  "block.minecraft.pink_candle_cake": "분홍색 초를 꽂은 케이크",
  "block.minecraft.pink_carpet": "분홍색 양탄자",
  "block.minecraft.pink_concrete": "분홍색 콘크리트",
  "block.minecraft.pink_concrete_powder": "분홍색 콘크리트 가루",
  "block.minecraft.pink_glazed_terracotta": "분홍색 유광 테라코타",
  "block.minecraft.pink_petals": "분홍 꽃잎",
  "block.minecraft.pink_shulker_box": "분홍색 셜커 상자",
  "block.minecraft.pink_stained_glass": "분홍색 색유리",
  "block.minecraft.pink_stained_glass_pane": "분홍색 색유리 판",
  "block.minecraft.pink_terracotta": "분홍색 테라코타",
  "block.minecraft.pink_tulip": "분홍색 튤립",
  "block.minecraft.pink_wool": "분홍색 양털",
  "block.minecraft.piston": "피스톤",
  "block.minecraft.piston_head": "피스톤 머리",
  "block.minecraft.pitcher_crop": "벌레잡이풀 작물",
  "block.minecraft.pitcher_plant": "벌레잡이풀",
  "block.minecraft.player_head": "플레이어 머리",
  "block.minecraft.player_head.named": "%s의 머리",
  "block.minecraft.player_wall_head": "플레이어 벽 머리",
  "block.minecraft.podzol": "회백토",
  "block.minecraft.pointed_dripstone": "뾰족한 점적석",
  "block.minecraft.polished_andesite": "윤나는 안산암",
  "block.minecraft.polished_andesite_slab": "윤나는 안산암 반 블록",
  "block.minecraft.polished_andesite_stairs": "윤나는 안산암 계단",
  "block.minecraft.polished_basalt": "윤나는 현무암",
  "block.minecraft.polished_blackstone": "윤나는 흑암",
  "block.minecraft.polished_blackstone_brick_slab": "윤나는 흑암 벽돌 반 블록",
  "block.minecraft.polished_blackstone_brick_stairs": "윤나는 흑암 벽돌 계단",
  "block.minecraft.polished_blackstone_brick_wall": "윤나는 흑암 벽돌 담장",
  "block.minecraft.polished_blackstone_bricks": "윤나는 흑암 벽돌",
  "block.minecraft.polished_blackstone_button": "윤나는 흑암 버튼",
  "block.minecraft.polished_blackstone_pressure_plate": "윤나는 흑암 압력판",
  "block.minecraft.polished_blackstone_slab": "윤나는 흑암 반 블록",
  "block.minecraft.polished_blackstone_stairs": "윤나는 흑암 계단",
  "block.minecraft.polished_blackstone_wall": "윤나는 흑암 담장",
  "block.minecraft.polished_deepslate": "윤나는 심층암",
  "block.minecraft.polished_deepslate_slab": "윤나는 심층암 반 블록",
  "block.minecraft.polished_deepslate_stairs": "윤나는 심층암 계단",
  "block.minecraft.polished_deepslate_wall": "윤나는 심층암 담장",
  "block.minecraft.polished_diorite": "윤나는 섬록암",
  "block.minecraft.polished_diorite_slab": "윤나는 섬록암 반 블록",
  "block.minecraft.polished_diorite_stairs": "윤나는 섬록암 계단",
  "block.minecraft.polished_granite": "윤나는 화강암",
  "block.minecraft.polished_granite_slab": "윤나는 화강암 반 블록",
  "block.minecraft.polished_granite_stairs": "윤나는 화강암 계단",
  "block.minecraft.polished_tuff": "윤나는 응회암",
  "block.minecraft.polished_tuff_slab": "윤나는 응회암 반 블록",
  "block.minecraft.polished_tuff_stairs": "윤나는 응회암 계단",
  "block.minecraft.polished_tuff_wall": "윤나는 응회암 담장",
  "block.minecraft.poppy": "양귀비",
  "block.minecraft.potatoes": "감자",
  "block.minecraft.potted_acacia_sapling": "화분에 심은 아카시아나무 묘목",
  "block.minecraft.potted_allium": "화분에 심은 알리움",
  "block.minecraft.potted_azalea_bush": "화분에 심은 진달래",
  "block.minecraft.potted_azure_bluet": "화분에 심은 선애기별꽃",
  "block.minecraft.potted_bamboo": "화분에 심은 대나무",
  "block.minecraft.potted_birch_sapling": "화분에 심은 자작나무 묘목",
  "block.minecraft.potted_blue_orchid": "화분에 심은 파란색 난초",
  "block.minecraft.potted_brown_mushroom": "화분에 심은 갈색 버섯",
  "block.minecraft.potted_cactus": "화분에 심은 선인장",
  "block.minecraft.potted_cherry_sapling": "화분에 심은 벚나무 묘목",
  "block.minecraft.potted_closed_eyeblossom": "화분에 심은 감은 눈망울꽃",
  "block.minecraft.potted_cornflower": "화분에 심은 수레국화",
  "block.minecraft.potted_crimson_fungus": "화분에 심은 진홍빛 균",
  "block.minecraft.potted_crimson_roots": "화분에 심은 진홍빛 뿌리",
  "block.minecraft.potted_dandelion": "화분에 심은 민들레",
  "block.minecraft.potted_dark_oak_sapling": "화분에 심은 짙은 참나무 묘목",
  "block.minecraft.potted_dead_bush": "화분에 심은 마른 덤불",
  "block.minecraft.potted_fern": "화분에 심은 고사리",
  "block.minecraft.potted_flowering_azalea_bush": "화분에 심은 꽃 핀 진달래",
  "block.minecraft.potted_golden_dandelion": "화분에 심은 황금 민들레",
  "block.minecraft.potted_jungle_sapling": "화분에 심은 정글나무 묘목",
  "block.minecraft.potted_lily_of_the_valley": "화분에 심은 은방울꽃",
  "block.minecraft.potted_mangrove_propagule": "화분에 심은 맹그로브나무 주아",
  "block.minecraft.potted_oak_sapling": "화분에 심은 참나무 묘목",
  "block.minecraft.potted_open_eyeblossom": "화분에 심은 뜬 눈망울꽃",
  "block.minecraft.potted_orange_tulip": "화분에 심은 주황색 튤립",
  "block.minecraft.potted_oxeye_daisy": "화분에 심은 데이지",
  "block.minecraft.potted_pale_oak_sapling": "화분에 심은 창백한 참나무 묘목",
  "block.minecraft.potted_pink_tulip": "화분에 심은 분홍색 튤립",
  "block.minecraft.potted_poppy": "화분에 심은 양귀비",
  "block.minecraft.potted_red_mushroom": "화분에 심은 빨간색 버섯",
  "block.minecraft.potted_red_tulip": "화분에 심은 빨간색 튤립",
  "block.minecraft.potted_spruce_sapling": "화분에 심은 가문비나무 묘목",
  "block.minecraft.potted_torchflower": "화분에 심은 횃불꽃",
  "block.minecraft.potted_warped_fungus": "화분에 심은 뒤틀린 균",
  "block.minecraft.potted_warped_roots": "화분에 심은 뒤틀린 뿌리",
  "block.minecraft.potted_white_tulip": "화분에 심은 하얀색 튤립",
  "block.minecraft.potted_wither_rose": "화분에 심은 위더 장미",
  "block.minecraft.powder_snow": "가루눈",
  "block.minecraft.powder_snow_cauldron": "가루눈 가마솥",
  "block.minecraft.powered_rail": "동력 레일",
  "block.minecraft.prismarine": "프리즈머린",
  "block.minecraft.prismarine_brick_slab": "프리즈머린 벽돌 반 블록",
  "block.minecraft.prismarine_brick_stairs": "프리즈머린 벽돌 계단",
  "block.minecraft.prismarine_bricks": "프리즈머린 벽돌",
  "block.minecraft.prismarine_slab": "프리즈머린 반 블록",
  "block.minecraft.prismarine_stairs": "프리즈머린 계단",
  "block.minecraft.prismarine_wall": "프리즈머린 담장",
  "block.minecraft.pumpkin": "호박",
  "block.minecraft.pumpkin_stem": "호박 줄기",
  "block.minecraft.purple_banner": "보라색 현수막",
  "block.minecraft.purple_bed": "보라색 침대",
  "block.minecraft.purple_candle": "보라색 초",
  "block.minecraft.purple_candle_cake": "보라색 초를 꽂은 케이크",
  "block.minecraft.purple_carpet": "보라색 양탄자",
  "block.minecraft.purple_concrete": "보라색 콘크리트",
  "block.minecraft.purple_concrete_powder": "보라색 콘크리트 가루",
  "block.minecraft.purple_glazed_terracotta": "보라색 유광 테라코타",
  "block.minecraft.purple_shulker_box": "보라색 셜커 상자",
  "block.minecraft.purple_stained_glass": "보라색 색유리",
  "block.minecraft.purple_stained_glass_pane": "보라색 색유리 판",
  "block.minecraft.purple_terracotta": "보라색 테라코타",
  "block.minecraft.purple_wool": "보라색 양털",
  "block.minecraft.purpur_block": "퍼퍼 블록",
  "block.minecraft.purpur_pillar": "퍼퍼 기둥",
  "block.minecraft.purpur_slab": "퍼퍼 반 블록",
  "block.minecraft.purpur_stairs": "퍼퍼 계단",
  "block.minecraft.quartz_block": "석영 블록",
  "block.minecraft.quartz_bricks": "석영 벽돌",
  "block.minecraft.quartz_pillar": "석영 기둥",
  "block.minecraft.quartz_slab": "석영 반 블록",
  "block.minecraft.quartz_stairs": "석영 계단",
  "block.minecraft.rail": "레일",
  "block.minecraft.raw_copper_block": "구리 원석 블록",
  "block.minecraft.raw_gold_block": "금 원석 블록",
  "block.minecraft.raw_iron_block": "철 원석 블록",
  "block.minecraft.red_banner": "빨간색 현수막",
  "block.minecraft.red_bed": "빨간색 침대",
  "block.minecraft.red_candle": "빨간색 초",
  "block.minecraft.red_candle_cake": "빨간색 초를 꽂은 케이크",
  "block.minecraft.red_carpet": "빨간색 양탄자",
  "block.minecraft.red_concrete": "빨간색 콘크리트",
  "block.minecraft.red_concrete_powder": "빨간색 콘크리트 가루",
  "block.minecraft.red_glazed_terracotta": "빨간색 유광 테라코타",
  "block.minecraft.red_mushroom": "빨간색 버섯",
  "block.minecraft.red_mushroom_block": "빨간색 버섯 블록",
  "block.minecraft.red_nether_brick_slab": "붉은 네더 벽돌 반 블록",
  "block.minecraft.red_nether_brick_stairs": "붉은 네더 벽돌 계단",
  "block.minecraft.red_nether_brick_wall": "붉은 네더 벽돌 담장",
  "block.minecraft.red_nether_bricks": "붉은 네더 벽돌",
  "block.minecraft.red_sand": "붉은 모래",
  "block.minecraft.red_sandstone": "붉은 사암",
  "block.minecraft.red_sandstone_slab": "붉은 사암 반 블록",
  "block.minecraft.red_sandstone_stairs": "붉은 사암 계단",
  "block.minecraft.red_sandstone_wall": "붉은 사암 담장",
  "block.minecraft.red_shulker_box": "빨간색 셜커 상자",
  "block.minecraft.red_stained_glass": "빨간색 색유리",
  "block.minecraft.red_stained_glass_pane": "빨간색 색유리 판",
  "block.minecraft.red_terracotta": "빨간색 테라코타",
  "block.minecraft.red_tulip": "빨간색 튤립",
  "block.minecraft.red_wool": "빨간색 양털",
  "block.minecraft.redstone_block": "레드스톤 블록",
  "block.minecraft.redstone_lamp": "레드스톤 조명",
  "block.minecraft.redstone_ore": "레드스톤 광석",
  "block.minecraft.redstone_torch": "레드스톤 횃불",
  "block.minecraft.redstone_wall_torch": "레드스톤 벽 횃불",
  "block.minecraft.redstone_wire": "레드스톤 선",
  "block.minecraft.reinforced_deepslate": "보강된 심층암",
  "block.minecraft.repeater": "레드스톤 중계기",
  "block.minecraft.repeating_command_block": "반복형 명령 블록",
  "block.minecraft.resin_block": "수지 블록",
  "block.minecraft.resin_brick_slab": "수지 벽돌 반 블록",
  "block.minecraft.resin_brick_stairs": "수지 벽돌 계단",
  "block.minecraft.resin_brick_wall": "수지 벽돌 담장",
  "block.minecraft.resin_bricks": "수지 벽돌",
  "block.minecraft.resin_clump": "수지 덩어리",
  "block.minecraft.respawn_anchor": "리스폰 정박기",
  "block.minecraft.rooted_dirt": "뿌리내린 흙",
  "block.minecraft.rose_bush": "장미 덤불",
  "block.minecraft.sand": "모래",
  "block.minecraft.sandstone": "사암",
  "block.minecraft.sandstone_slab": "사암 반 블록",
  "block.minecraft.sandstone_stairs": "사암 계단",
  "block.minecraft.sandstone_wall": "사암 담장",
  "block.minecraft.scaffolding": "비계",
  "block.minecraft.sculk": "스컬크",
  "block.minecraft.sculk_catalyst": "스컬크 촉매",
  "block.minecraft.sculk_sensor": "스컬크 감지체",
  "block.minecraft.sculk_shrieker": "스컬크 비명체",
  "block.minecraft.sculk_vein": "스컬크 정맥",
  "block.minecraft.sea_lantern": "바다 랜턴",
  "block.minecraft.sea_pickle": "불우렁쉥이",
  "block.minecraft.seagrass": "해초",
  "block.minecraft.set_spawn": "리스폰 지점을 설정했습니다",
  "block.minecraft.short_dry_grass": "키 작은 마른 잔디",
  "block.minecraft.short_grass": "키 작은 잔디",
  "block.minecraft.shroomlight": "버섯불",
  "block.minecraft.shulker_box": "셜커 상자",
  "block.minecraft.skeleton_skull": "스켈레톤 해골",
  "block.minecraft.skeleton_wall_skull": "스켈레톤 벽 해골",
  "block.minecraft.slime_block": "슬라임 블록",
  "block.minecraft.small_amethyst_bud": "작은 자수정 봉오리",
  "block.minecraft.small_dripleaf": "작은 흘림잎",
  "block.minecraft.smithing_table": "대장장이 작업대",
  "block.minecraft.smoker": "훈연기",
  "block.minecraft.smooth_basalt": "매끄러운 현무암",
  "block.minecraft.smooth_quartz": "매끄러운 석영 블록",
  "block.minecraft.smooth_quartz_slab": "매끄러운 석영 반 블록",
  "block.minecraft.smooth_quartz_stairs": "매끄러운 석영 계단",
  "block.minecraft.smooth_red_sandstone": "매끄러운 붉은 사암",
  "block.minecraft.smooth_red_sandstone_slab": "매끄러운 붉은 사암 반 블록",
  "block.minecraft.smooth_red_sandstone_stairs": "매끄러운 붉은 사암 계단",
  "block.minecraft.smooth_sandstone": "매끄러운 사암",
  "block.minecraft.smooth_sandstone_slab": "매끄러운 사암 반 블록",
  "block.minecraft.smooth_sandstone_stairs": "매끄러운 사암 계단",
  "block.minecraft.smooth_stone": "매끄러운 돌",
  "block.minecraft.smooth_stone_slab": "매끄러운 돌 반 블록",
  "block.minecraft.sniffer_egg": "스니퍼 알",
  "block.minecraft.snow": "눈",
  "block.minecraft.snow_block": "눈 블록",
  "block.minecraft.soul_campfire": "영혼 모닥불",
  "block.minecraft.soul_fire": "영혼 불",
  "block.minecraft.soul_lantern": "영혼 랜턴",
  "block.minecraft.soul_sand": "영혼 모래",
  "block.minecraft.soul_soil": "영혼 흙",
  "block.minecraft.soul_torch": "영혼 횃불",
  "block.minecraft.soul_wall_torch": "영혼 벽 횃불",
  "block.minecraft.spawn.not_valid": "당신의 집 침대 또는 충전된 리스폰 정박기가 없거나, 가로막혀 있습니다",
  "block.minecraft.spawner": "몬스터 생성기",
  "block.minecraft.spawner.desc1": "생성 알을 든 채 사용:",
  "block.minecraft.spawner.desc2": "몹 유형 설정",
  "block.minecraft.sponge": "스펀지",
  "block.minecraft.spore_blossom": "포자 꽃",
  "block.minecraft.spruce_button": "가문비나무 버튼",
  "block.minecraft.spruce_door": "가문비나무 문",
  "block.minecraft.spruce_fence": "가문비나무 울타리",
  "block.minecraft.spruce_fence_gate": "가문비나무 울타리 문",
  "block.minecraft.spruce_hanging_sign": "가문비나무 매다는 표지판",
  "block.minecraft.spruce_leaves": "가문비나무 잎",
  "block.minecraft.spruce_log": "가문비나무 원목",
  "block.minecraft.spruce_planks": "가문비나무 판자",
  "block.minecraft.spruce_pressure_plate": "가문비나무 압력판",
  "block.minecraft.spruce_sapling": "가문비나무 묘목",
  "block.minecraft.spruce_shelf": "가문비나무 선반",
  "block.minecraft.spruce_sign": "가문비나무 표지판",
  "block.minecraft.spruce_slab": "가문비나무 반 블록",
  "block.minecraft.spruce_stairs": "가문비나무 계단",
  "block.minecraft.spruce_trapdoor": "가문비나무 다락문",
  "block.minecraft.spruce_wall_hanging_sign": "가문비나무 벽 매다는 표지판",
  "block.minecraft.spruce_wall_sign": "가문비나무 벽 표지판",
  "block.minecraft.spruce_wood": "가문비나무",
  "block.minecraft.sticky_piston": "끈끈이 피스톤",
  "block.minecraft.stone": "돌",
  "block.minecraft.stone_brick_slab": "석재 벽돌 반 블록",
  "block.minecraft.stone_brick_stairs": "석재 벽돌 계단",
  "block.minecraft.stone_brick_wall": "석재 벽돌 담장",
  "block.minecraft.stone_bricks": "석재 벽돌",
  "block.minecraft.stone_button": "돌 버튼",
  "block.minecraft.stone_pressure_plate": "돌 압력판",
  "block.minecraft.stone_slab": "돌 반 블록",
  "block.minecraft.stone_stairs": "돌 계단",
  "block.minecraft.stonecutter": "석재 절단기",
  "block.minecraft.stripped_acacia_log": "껍질 벗긴 아카시아나무 원목",
  "block.minecraft.stripped_acacia_wood": "껍질 벗긴 아카시아나무",
  "block.minecraft.stripped_bamboo_block": "껍질 벗긴 대나무 블록",
  "block.minecraft.stripped_birch_log": "껍질 벗긴 자작나무 원목",
  "block.minecraft.stripped_birch_wood": "껍질 벗긴 자작나무",
  "block.minecraft.stripped_cherry_log": "껍질 벗긴 벚나무 원목",
  "block.minecraft.stripped_cherry_wood": "껍질 벗긴 벚나무",
  "block.minecraft.stripped_crimson_hyphae": "껍질 벗긴 진홍빛 균사",
  "block.minecraft.stripped_crimson_stem": "껍질 벗긴 진홍빛 자루",
  "block.minecraft.stripped_dark_oak_log": "껍질 벗긴 짙은 참나무 원목",
  "block.minecraft.stripped_dark_oak_wood": "껍질 벗긴 짙은 참나무",
  "block.minecraft.stripped_jungle_log": "껍질 벗긴 정글나무 원목",
  "block.minecraft.stripped_jungle_wood": "껍질 벗긴 정글나무",
  "block.minecraft.stripped_mangrove_log": "껍질 벗긴 맹그로브나무 원목",
  "block.minecraft.stripped_mangrove_wood": "껍질 벗긴 맹그로브나무",
  "block.minecraft.stripped_oak_log": "껍질 벗긴 참나무 원목",
  "block.minecraft.stripped_oak_wood": "껍질 벗긴 참나무",
  "block.minecraft.stripped_pale_oak_log": "껍질 벗긴 창백한 참나무 원목",
  "block.minecraft.stripped_pale_oak_wood": "껍질 벗긴 창백한 참나무",
  "block.minecraft.stripped_spruce_log": "껍질 벗긴 가문비나무 원목",
  "block.minecraft.stripped_spruce_wood": "껍질 벗긴 가문비나무",
  "block.minecraft.stripped_warped_hyphae": "껍질 벗긴 뒤틀린 균사",
  "block.minecraft.stripped_warped_stem": "껍질 벗긴 뒤틀린 자루",
  "block.minecraft.structure_block": "구조물 블록",
  "block.minecraft.structure_void": "구조물 공허 공간",
  "block.minecraft.sugar_cane": "사탕수수",
  "block.minecraft.sunflower": "해바라기",
  "block.minecraft.suspicious_gravel": "수상한 자갈",
  "block.minecraft.suspicious_sand": "수상한 모래",
  "block.minecraft.sweet_berry_bush": "달콤한 열매 덤불",
  "block.minecraft.tall_dry_grass": "키 큰 마른 잔디",
  "block.minecraft.tall_grass": "키 큰 잔디",
  "block.minecraft.tall_seagrass": "키 큰 해초",
  "block.minecraft.target": "과녁",
  "block.minecraft.terracotta": "테라코타",
  "block.minecraft.test_block": "테스트 블록",
  "block.minecraft.test_instance_block": "테스트 인스턴스 블록",
  "block.minecraft.tinted_glass": "차광 유리",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT 폭발이 꺼져 있습니다",
  "block.minecraft.torch": "횃불",
  "block.minecraft.torchflower": "횃불꽃",
  "block.minecraft.torchflower_crop": "횃불꽃 작물",
  "block.minecraft.trapped_chest": "덫 상자",
  "block.minecraft.trial_spawner": "시련 생성기",
  "block.minecraft.tripwire": "철사 덫",
  "block.minecraft.tripwire_hook": "철사 덫 갈고리",
  "block.minecraft.tube_coral": "관 산호",
  "block.minecraft.tube_coral_block": "관 산호 블록",
  "block.minecraft.tube_coral_fan": "부채형 관 산호",
  "block.minecraft.tube_coral_wall_fan": "부채형 관 산호 벽",
  "block.minecraft.tuff": "응회암",
  "block.minecraft.tuff_brick_slab": "응회암 벽돌 반 블록",
  "block.minecraft.tuff_brick_stairs": "응회암 벽돌 계단",
  "block.minecraft.tuff_brick_wall": "응회암 벽돌 담장",
  "block.minecraft.tuff_bricks": "응회암 벽돌",
  "block.minecraft.tuff_slab": "응회암 반 블록",
  "block.minecraft.tuff_stairs": "응회암 계단",
  "block.minecraft.tuff_wall": "응회암 담장",
  "block.minecraft.turtle_egg": "거북알",
  "block.minecraft.twisting_vines": "휘어진 덩굴",
  "block.minecraft.twisting_vines_plant": "휘어진 덩굴 식물",
  "block.minecraft.vault": "금고",
  "block.minecraft.verdant_froglight": "잔딧빛 개구리불",
  "block.minecraft.vine": "덩굴",
  "block.minecraft.void_air": "공허 공기",
  "block.minecraft.wall_torch": "벽 횃불",
  "block.minecraft.warped_button": "뒤틀린 버튼",
  "block.minecraft.warped_door": "뒤틀린 문",
  "block.minecraft.warped_fence": "뒤틀린 울타리",
  "block.minecraft.warped_fence_gate": "뒤틀린 울타리 문",
  "block.minecraft.warped_fungus": "뒤틀린 균",
  "block.minecraft.warped_hanging_sign": "뒤틀린 매다는 표지판",
  "block.minecraft.warped_hyphae": "뒤틀린 균사",
  "block.minecraft.warped_nylium": "뒤틀린 네사체",
  "block.minecraft.warped_planks": "뒤틀린 판자",
  "block.minecraft.warped_pressure_plate": "뒤틀린 압력판",
  "block.minecraft.warped_roots": "뒤틀린 뿌리",
  "block.minecraft.warped_shelf": "뒤틀린 선반",
  "block.minecraft.warped_sign": "뒤틀린 표지판",
  "block.minecraft.warped_slab": "뒤틀린 반 블록",
  "block.minecraft.warped_stairs": "뒤틀린 계단",
  "block.minecraft.warped_stem": "뒤틀린 자루",
  "block.minecraft.warped_trapdoor": "뒤틀린 다락문",
  "block.minecraft.warped_wall_hanging_sign": "뒤틀린 벽 매다는 표지판",
  "block.minecraft.warped_wall_sign": "뒤틀린 벽 표지판",
  "block.minecraft.warped_wart_block": "뒤틀린 사마귀 블록",
  "block.minecraft.water": "물",
  "block.minecraft.water_cauldron": "물 가마솥",
  "block.minecraft.waxed_chiseled_copper": "밀랍칠한 조각된 구리",
  "block.minecraft.waxed_copper_bars": "밀랍칠한 구리 창살",
  "block.minecraft.waxed_copper_block": "밀랍칠한 구리 블록",
  "block.minecraft.waxed_copper_bulb": "밀랍칠한 구리 전구",
  "block.minecraft.waxed_copper_chain": "밀랍칠한 구리 사슬",
  "block.minecraft.waxed_copper_chest": "밀랍칠한 구리 상자",
  "block.minecraft.waxed_copper_door": "밀랍칠한 구리 문",
  "block.minecraft.waxed_copper_golem_statue": "밀랍칠한 구리 골렘 동상",
  "block.minecraft.waxed_copper_grate": "밀랍칠한 구리 격자",
  "block.minecraft.waxed_copper_lantern": "밀랍칠한 구리 랜턴",
  "block.minecraft.waxed_copper_trapdoor": "밀랍칠한 구리 다락문",
  "block.minecraft.waxed_cut_copper": "밀랍칠한 깎인 구리",
  "block.minecraft.waxed_cut_copper_slab": "밀랍칠한 깎인 구리 반 블록",
  "block.minecraft.waxed_cut_copper_stairs": "밀랍칠한 깎인 구리 계단",
  "block.minecraft.waxed_exposed_chiseled_copper": "밀랍칠한 약간 녹슨 조각된 구리",
  "block.minecraft.waxed_exposed_copper": "밀랍칠한 약간 녹슨 구리",
  "block.minecraft.waxed_exposed_copper_bars": "밀랍칠한 약간 녹슨 구리 창살",
  "block.minecraft.waxed_exposed_copper_bulb": "밀랍칠한 약간 녹슨 구리 전구",
  "block.minecraft.waxed_exposed_copper_chain": "밀랍칠한 약간 녹슨 구리 사슬",
  "block.minecraft.waxed_exposed_copper_chest": "밀랍칠한 약간 녹슨 구리 상자",
  "block.minecraft.waxed_exposed_copper_door": "밀랍칠한 약간 녹슨 구리 문",
  "block.minecraft.waxed_exposed_copper_golem_statue": "밀랍칠한 약간 녹슨 구리 골렘 동상",
  "block.minecraft.waxed_exposed_copper_grate": "밀랍칠한 약간 녹슨 구리 격자",
  "block.minecraft.waxed_exposed_copper_lantern": "밀랍칠한 약간 녹슨 구리 랜턴",
  "block.minecraft.waxed_exposed_copper_trapdoor": "밀랍칠한 약간 녹슨 구리 다락문",
  "block.minecraft.waxed_exposed_cut_copper": "밀랍칠한 약간 녹슨 깎인 구리",
  "block.minecraft.waxed_exposed_cut_copper_slab": "밀랍칠한 약간 녹슨 깎인 구리 반 블록",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "밀랍칠한 약간 녹슨 깎인 구리 계단",
  "block.minecraft.waxed_exposed_lightning_rod": "밀랍칠한 약간 녹슨 피뢰침",
  "block.minecraft.waxed_lightning_rod": "밀랍칠한 피뢰침",
  "block.minecraft.waxed_oxidized_chiseled_copper": "밀랍칠한 산화된 조각된 구리",
  "block.minecraft.waxed_oxidized_copper": "밀랍칠한 산화된 구리",
  "block.minecraft.waxed_oxidized_copper_bars": "밀랍칠한 산화된 구리 창살",
  "block.minecraft.waxed_oxidized_copper_bulb": "밀랍칠한 산화된 구리 전구",
  "block.minecraft.waxed_oxidized_copper_chain": "밀랍칠한 산화된 구리 사슬",
  "block.minecraft.waxed_oxidized_copper_chest": "밀랍칠한 산화된 구리 상자",
  "block.minecraft.waxed_oxidized_copper_door": "밀랍칠한 산화된 구리 문",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "밀랍칠한 산화된 구리 골렘 동상",
  "block.minecraft.waxed_oxidized_copper_grate": "밀랍칠한 산화된 구리 격자",
  "block.minecraft.waxed_oxidized_copper_lantern": "밀랍칠한 산화된 구리 랜턴",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "밀랍칠한 산화된 구리 다락문",
  "block.minecraft.waxed_oxidized_cut_copper": "밀랍칠한 산화된 깎인 구리",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "밀랍칠한 산화된 깎인 구리 반 블록",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "밀랍칠한 산화된 깎인 구리 계단",
  "block.minecraft.waxed_oxidized_lightning_rod": "밀랍칠한 산화된 피뢰침",
  "block.minecraft.waxed_weathered_chiseled_copper": "밀랍칠한 녹슨 조각된 구리",
  "block.minecraft.waxed_weathered_copper": "밀랍칠한 녹슨 구리",
  "block.minecraft.waxed_weathered_copper_bars": "밀랍칠한 녹슨 구리 창살",
  "block.minecraft.waxed_weathered_copper_bulb": "밀랍칠한 녹슨 구리 전구",
  "block.minecraft.waxed_weathered_copper_chain": "밀랍칠한 녹슨 구리 사슬",
  "block.minecraft.waxed_weathered_copper_chest": "밀랍칠한 녹슨 구리 상자",
  "block.minecraft.waxed_weathered_copper_door": "밀랍칠한 녹슨 구리 문",
  "block.minecraft.waxed_weathered_copper_golem_statue": "밀랍칠한 녹슨 구리 골렘 동상",
  "block.minecraft.waxed_weathered_copper_grate": "밀랍칠한 녹슨 구리 격자",
  "block.minecraft.waxed_weathered_copper_lantern": "밀랍칠한 녹슨 구리 랜턴",
  "block.minecraft.waxed_weathered_copper_trapdoor": "밀랍칠한 녹슨 구리 다락문",
  "block.minecraft.waxed_weathered_cut_copper": "밀랍칠한 녹슨 깎인 구리",
  "block.minecraft.waxed_weathered_cut_copper_slab": "밀랍칠한 녹슨 깎인 구리 반 블록",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "밀랍칠한 녹슨 깎인 구리 계단",
  "block.minecraft.waxed_weathered_lightning_rod": "밀랍칠한 녹슨 피뢰침",
  "block.minecraft.weathered_chiseled_copper": "녹슨 조각된 구리",
  "block.minecraft.weathered_copper": "녹슨 구리",
  "block.minecraft.weathered_copper_bars": "녹슨 구리 창살",
  "block.minecraft.weathered_copper_bulb": "녹슨 구리 전구",
  "block.minecraft.weathered_copper_chain": "녹슨 구리 사슬",
  "block.minecraft.weathered_copper_chest": "녹슨 구리 상자",
  "block.minecraft.weathered_copper_door": "녹슨 구리 문",
  "block.minecraft.weathered_copper_golem_statue": "녹슨 구리 골렘 동상",
  "block.minecraft.weathered_copper_grate": "녹슨 구리 격자",
  "block.minecraft.weathered_copper_lantern": "녹슨 구리 랜턴",
  "block.minecraft.weathered_copper_trapdoor": "녹슨 구리 다락문",
  "block.minecraft.weathered_cut_copper": "녹슨 깎인 구리",
  "block.minecraft.weathered_cut_copper_slab": "녹슨 깎인 구리 반 블록",
  "block.minecraft.weathered_cut_copper_stairs": "녹슨 깎인 구리 계단",
  "block.minecraft.weathered_lightning_rod": "녹슨 피뢰침",
  "block.minecraft.weeping_vines": "늘어진 덩굴",
  "block.minecraft.weeping_vines_plant": "늘어진 덩굴 식물",
  "block.minecraft.wet_sponge": "젖은 스펀지",
  "block.minecraft.wheat": "밀 작물",
  "block.minecraft.white_banner": "하얀색 현수막",
  "block.minecraft.white_bed": "하얀색 침대",
  "block.minecraft.white_candle": "하얀색 초",
  "block.minecraft.white_candle_cake": "하얀색 초를 꽂은 케이크",
  "block.minecraft.white_carpet": "하얀색 양탄자",
  "block.minecraft.white_concrete": "하얀색 콘크리트",
  "block.minecraft.white_concrete_powder": "하얀색 콘크리트 가루",
  "block.minecraft.white_glazed_terracotta": "하얀색 유광 테라코타",
  "block.minecraft.white_shulker_box": "하얀색 셜커 상자",
  "block.minecraft.white_stained_glass": "하얀색 색유리",
  "block.minecraft.white_stained_glass_pane": "하얀색 색유리 판",
  "block.minecraft.white_terracotta": "하얀색 테라코타",
  "block.minecraft.white_tulip": "하얀색 튤립",
  "block.minecraft.white_wool": "하얀색 양털",
  "block.minecraft.wildflowers": "들꽃",
  "block.minecraft.wither_rose": "위더 장미",
  "block.minecraft.wither_skeleton_skull": "위더 스켈레톤 해골",
  "block.minecraft.wither_skeleton_wall_skull": "위더 스켈레톤 벽 해골",
  "block.minecraft.yellow_banner": "노란색 현수막",
  "block.minecraft.yellow_bed": "노란색 침대",
  "block.minecraft.yellow_candle": "노란색 초",
  "block.minecraft.yellow_candle_cake": "노란색 초를 꽂은 케이크",
  "block.minecraft.yellow_carpet": "노란색 양탄자",
  "block.minecraft.yellow_concrete": "노란색 콘크리트",
  "block.minecraft.yellow_concrete_powder": "노란색 콘크리트 가루",
  "block.minecraft.yellow_glazed_terracotta": "노란색 유광 테라코타",
  "block.minecraft.yellow_shulker_box": "노란색 셜커 상자",
  "block.minecraft.yellow_stained_glass": "노란색 색유리",
  "block.minecraft.yellow_stained_glass_pane": "노란색 색유리 판",
  "block.minecraft.yellow_terracotta": "노란색 테라코타",
  "block.minecraft.yellow_wool": "노란색 양털",
  "block.minecraft.zombie_head": "좀비 머리",
  "block.minecraft.zombie_wall_head": "좀비 벽 머리",
  "item.minecraft.acacia_boat": "아카시아나무 보트",
  "item.minecraft.acacia_chest_boat": "상자가 실린 아카시아나무 보트",
  "item.minecraft.allay_spawn_egg": "알레이 생성 알",
  "item.minecraft.amethyst_shard": "자수정 조각",
  "item.minecraft.angler_pottery_shard": "낚시꾼 도자기 조각",
  "item.minecraft.angler_pottery_sherd": "낚시꾼 도자기 조각",
  "item.minecraft.apple": "사과",
  "item.minecraft.archer_pottery_shard": "궁수 도자기 조각",
  "item.minecraft.archer_pottery_sherd": "궁수 도자기 조각",
  "item.minecraft.armadillo_scute": "아르마딜로 인갑",
  "item.minecraft.armadillo_spawn_egg": "아르마딜로 생성 알",
  "item.minecraft.armor_stand": "갑옷 거치대",
  "item.minecraft.arms_up_pottery_shard": "만세 도자기 조각",
  "item.minecraft.arms_up_pottery_sherd": "만세 도자기 조각",
  "item.minecraft.arrow": "화살",
  "item.minecraft.axolotl_bucket": "아홀로틀이 담긴 양동이",
  "item.minecraft.axolotl_spawn_egg": "아홀로틀 생성 알",
  "item.minecraft.baked_potato": "구운 감자",
  "item.minecraft.bamboo_chest_raft": "상자가 실린 대나무 뗏목",
  "item.minecraft.bamboo_raft": "대나무 뗏목",
  "item.minecraft.bat_spawn_egg": "박쥐 생성 알",
  "item.minecraft.bee_spawn_egg": "꿀벌 생성 알",
  "item.minecraft.beef": "익히지 않은 소고기",
  "item.minecraft.beetroot": "비트",
  "item.minecraft.beetroot_seeds": "비트 씨앗",
  "item.minecraft.beetroot_soup": "비트 수프",
  "item.minecraft.birch_boat": "자작나무 보트",
  "item.minecraft.birch_chest_boat": "상자가 실린 자작나무 보트",
  "item.minecraft.black_bundle": "검은색 꾸러미",
  "item.minecraft.black_dye": "검은색 염료",
  "item.minecraft.black_harness": "검은색 하네스",
  "item.minecraft.blade_pottery_shard": "칼날 도자기 조각",
  "item.minecraft.blade_pottery_sherd": "칼날 도자기 조각",
  "item.minecraft.blaze_powder": "블레이즈 가루",
  "item.minecraft.blaze_rod": "블레이즈 막대기",
  "item.minecraft.blaze_spawn_egg": "블레이즈 생성 알",
  "item.minecraft.blue_bundle": "파란색 꾸러미",
  "item.minecraft.blue_dye": "파란색 염료",
  "item.minecraft.blue_egg": "파란색 달걀",
  "item.minecraft.blue_harness": "파란색 하네스",
  "item.minecraft.bogged_spawn_egg": "보그드 생성 알",
  "item.minecraft.bolt_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "나사 갑옷 장식",
  "item.minecraft.bone": "뼈다귀",
  "item.minecraft.bone_meal": "뼛가루",
  "item.minecraft.book": "책",
  "item.minecraft.bordure_indented_banner_pattern": "톱니 테두리 현수막 무늬",
  "item.minecraft.bow": "활",
  "item.minecraft.bowl": "그릇",
  "item.minecraft.bread": "빵",
  "item.minecraft.breeze_rod": "브리즈 막대기",
  "item.minecraft.breeze_spawn_egg": "브리즈 생성 알",
  "item.minecraft.brewer_pottery_shard": "양조가 도자기 조각",
  "item.minecraft.brewer_pottery_sherd": "양조가 도자기 조각",
  "item.minecraft.brewing_stand": "양조기",
  "item.minecraft.brick": "벽돌",
  "item.minecraft.brown_bundle": "갈색 꾸러미",
  "item.minecraft.brown_dye": "갈색 염료",
  "item.minecraft.brown_egg": "갈색 달걀",
  "item.minecraft.brown_harness": "갈색 하네스",
  "item.minecraft.brush": "솔",
  "item.minecraft.bucket": "양동이",
  "item.minecraft.bundle": "꾸러미",
  "item.minecraft.bundle.empty": "비어 있음",
  "item.minecraft.bundle.empty.description": "여러 종류의 아이템을 섞어 한 묶음 보관할 수 있습니다",
  "item.minecraft.bundle.full": "꽉 참",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "불탐 도자기 조각",
  "item.minecraft.burn_pottery_sherd": "불탐 도자기 조각",
  "item.minecraft.camel_husk_spawn_egg": "낙타 허스크 생성 알",
  "item.minecraft.camel_spawn_egg": "낙타 생성 알",
  "item.minecraft.carrot": "당근",
  "item.minecraft.carrot_on_a_stick": "당근 낚싯대",
  "item.minecraft.cat_spawn_egg": "고양이 생성 알",
  "item.minecraft.cauldron": "가마솥",
  "item.minecraft.cave_spider_spawn_egg": "동굴 거미 생성 알",
  "item.minecraft.chainmail_boots": "사슬 부츠",
  "item.minecraft.chainmail_chestplate": "사슬 흉갑",
  "item.minecraft.chainmail_helmet": "사슬 투구",
  "item.minecraft.chainmail_leggings": "사슬 레깅스",
  "item.minecraft.charcoal": "숯",
  "item.minecraft.cherry_boat": "벚나무 보트",
  "item.minecraft.cherry_chest_boat": "상자가 실린 벚나무 보트",
  "item.minecraft.chest_minecart": "상자가 실린 광산 수레",
  "item.minecraft.chicken": "익히지 않은 닭고기",
  "item.minecraft.chicken_spawn_egg": "닭 생성 알",
  "item.minecraft.chorus_fruit": "후렴과",
  "item.minecraft.clay_ball": "점토 덩이",
  "item.minecraft.clock": "시계",
  "item.minecraft.coal": "석탄",
  "item.minecraft.coast_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.coast_armor_trim_smithing_template.new": "해안 갑옷 장식",
  "item.minecraft.cocoa_beans": "코코아 콩",
  "item.minecraft.cod": "익히지 않은 대구",
  "item.minecraft.cod_bucket": "대구가 담긴 양동이",
  "item.minecraft.cod_spawn_egg": "대구 생성 알",
  "item.minecraft.command_block_minecart": "명령 블록이 실린 광산 수레",
  "item.minecraft.compass": "나침반",
  "item.minecraft.cooked_beef": "스테이크",
  "item.minecraft.cooked_chicken": "익힌 닭고기",
  "item.minecraft.cooked_cod": "익힌 대구",
  "item.minecraft.cooked_mutton": "익힌 양고기",
  "item.minecraft.cooked_porkchop": "익힌 돼지고기",
  "item.minecraft.cooked_rabbit": "익힌 토끼고기",
  "item.minecraft.cooked_salmon": "익힌 연어",
  "item.minecraft.cookie": "쿠키",
  "item.minecraft.copper_axe": "구리 도끼",
  "item.minecraft.copper_boots": "구리 부츠",
  "item.minecraft.copper_chestplate": "구리 흉갑",
  "item.minecraft.copper_golem_spawn_egg": "구리 골렘 생성 알",
  "item.minecraft.copper_helmet": "구리 투구",
  "item.minecraft.copper_hoe": "구리 괭이",
  "item.minecraft.copper_horse_armor": "구리 말 갑옷",
  "item.minecraft.copper_ingot": "구리 주괴",
  "item.minecraft.copper_leggings": "구리 레깅스",
  "item.minecraft.copper_nautilus_armor": "구리 앵무조개 갑옷",
  "item.minecraft.copper_nugget": "구리 조각",
  "item.minecraft.copper_pickaxe": "구리 곡괭이",
  "item.minecraft.copper_shovel": "구리 삽",
  "item.minecraft.copper_spear": "구리 창",
  "item.minecraft.copper_sword": "구리 검",
  "item.minecraft.cow_spawn_egg": "소 생성 알",
  "item.minecraft.creaking_spawn_egg": "크리킹 생성 알",
  "item.minecraft.creeper_banner_pattern": "현수막 무늬",
  "item.minecraft.creeper_banner_pattern.desc": "크리퍼 모양",
  "item.minecraft.creeper_banner_pattern.new": "크리퍼 모양 현수막 무늬",
  "item.minecraft.creeper_spawn_egg": "크리퍼 생성 알",
  "item.minecraft.crossbow": "쇠뇌",
  "item.minecraft.crossbow.projectile": "발사체:",
  "item.minecraft.crossbow.projectile.multiple": "발사체: %s x %s",
  "item.minecraft.crossbow.projectile.single": "발사체: %s",
  "item.minecraft.cyan_bundle": "청록색 꾸러미",
  "item.minecraft.cyan_dye": "청록색 염료",
  "item.minecraft.cyan_harness": "청록색 하네스",
  "item.minecraft.danger_pottery_shard": "위험 도자기 조각",
  "item.minecraft.danger_pottery_sherd": "위험 도자기 조각",
  "item.minecraft.dark_oak_boat": "짙은 참나무 보트",
  "item.minecraft.dark_oak_chest_boat": "상자가 실린 짙은 참나무 보트",
  "item.minecraft.debug_stick": "디버그 막대기",
  "item.minecraft.debug_stick.empty": "%s에게 속성이 없습니다",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) 선택함",
  "item.minecraft.debug_stick.update": "\"%s\"을(를) %s(으)로",
  "item.minecraft.diamond": "다이아몬드",
  "item.minecraft.diamond_axe": "다이아몬드 도끼",
  "item.minecraft.diamond_boots": "다이아몬드 부츠",
  "item.minecraft.diamond_chestplate": "다이아몬드 흉갑",
  "item.minecraft.diamond_helmet": "다이아몬드 투구",
  "item.minecraft.diamond_hoe": "다이아몬드 괭이",
  "item.minecraft.diamond_horse_armor": "다이아몬드 말 갑옷",
  "item.minecraft.diamond_leggings": "다이아몬드 레깅스",
  "item.minecraft.diamond_nautilus_armor": "다이아몬드 앵무조개 갑옷",
  "item.minecraft.diamond_pickaxe": "다이아몬드 곡괭이",
  "item.minecraft.diamond_shovel": "다이아몬드 삽",
  "item.minecraft.diamond_spear": "다이아몬드 창",
  "item.minecraft.diamond_sword": "다이아몬드 검",
  "item.minecraft.disc_fragment_5": "음반 파편",
  "item.minecraft.disc_fragment_5.desc": "음반 - 5",
  "item.minecraft.dolphin_spawn_egg": "돌고래 생성 알",
  "item.minecraft.donkey_spawn_egg": "당나귀 생성 알",
  "item.minecraft.dragon_breath": "드래곤의 숨결",
  "item.minecraft.dried_kelp": "말린 켈프",
  "item.minecraft.drowned_spawn_egg": "드라운드 생성 알",
  "item.minecraft.dune_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.dune_armor_trim_smithing_template.new": "사구 갑옷 장식",
  "item.minecraft.echo_shard": "메아리 조각",
  "item.minecraft.egg": "달걀",
  "item.minecraft.elder_guardian_spawn_egg": "엘더 가디언 생성 알",
  "item.minecraft.elytra": "겉날개",
  "item.minecraft.emerald": "에메랄드",
  "item.minecraft.enchanted_book": "마법이 부여된 책",
  "item.minecraft.enchanted_golden_apple": "마법이 부여된 황금 사과",
  "item.minecraft.end_crystal": "엔드 수정",
  "item.minecraft.ender_dragon_spawn_egg": "엔더 드래곤 생성 알",
  "item.minecraft.ender_eye": "엔더의 눈",
  "item.minecraft.ender_pearl": "엔더 진주",
  "item.minecraft.enderman_spawn_egg": "엔더맨 생성 알",
  "item.minecraft.endermite_spawn_egg": "엔더마이트 생성 알",
  "item.minecraft.evoker_spawn_egg": "소환사 생성 알",
  "item.minecraft.experience_bottle": "경험치 병",
  "item.minecraft.explorer_pottery_shard": "탐험가 도자기 조각",
  "item.minecraft.explorer_pottery_sherd": "탐험가 도자기 조각",
  "item.minecraft.eye_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.eye_armor_trim_smithing_template.new": "눈 갑옷 장식",
  "item.minecraft.feather": "깃털",
  "item.minecraft.fermented_spider_eye": "발효된 거미 눈",
  "item.minecraft.field_masoned_banner_pattern": "벽돌 현수막 무늬",
  "item.minecraft.filled_map": "지도",
  "item.minecraft.fire_charge": "화염구",
  "item.minecraft.firework_rocket": "폭죽 로켓",
  "item.minecraft.firework_rocket.flight": "체공 시간:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "폭죽 탄약",
  "item.minecraft.firework_star.black": "검은색",
  "item.minecraft.firework_star.blue": "파란색",
  "item.minecraft.firework_star.brown": "갈색",
  "item.minecraft.firework_star.custom_color": "사용자 지정",
  "item.minecraft.firework_star.cyan": "청록색",
  "item.minecraft.firework_star.fade_to": "사라지는 효과",
  "item.minecraft.firework_star.flicker": "반짝이는 효과",
  "item.minecraft.firework_star.gray": "회색",
  "item.minecraft.firework_star.green": "초록색",
  "item.minecraft.firework_star.light_blue": "하늘색",
  "item.minecraft.firework_star.light_gray": "회백색",
  "item.minecraft.firework_star.lime": "연두색",
  "item.minecraft.firework_star.magenta": "자홍색",
  "item.minecraft.firework_star.orange": "주황색",
  "item.minecraft.firework_star.pink": "분홍색",
  "item.minecraft.firework_star.purple": "보라색",
  "item.minecraft.firework_star.red": "빨간색",
  "item.minecraft.firework_star.shape": "알 수 없는 모양",
  "item.minecraft.firework_star.shape.burst": "폭발형",
  "item.minecraft.firework_star.shape.creeper": "크리퍼 모양",
  "item.minecraft.firework_star.shape.large_ball": "큰 구형",
  "item.minecraft.firework_star.shape.small_ball": "작은 구형",
  "item.minecraft.firework_star.shape.star": "별 모양",
  "item.minecraft.firework_star.trail": "잔상 효과",
  "item.minecraft.firework_star.white": "하얀색",
  "item.minecraft.firework_star.yellow": "노란색",
  "item.minecraft.fishing_rod": "낚싯대",
  "item.minecraft.flint": "부싯돌",
  "item.minecraft.flint_and_steel": "부싯돌과 부시",
  "item.minecraft.flow_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.flow_armor_trim_smithing_template.new": "흐름 갑옷 장식",
  "item.minecraft.flow_banner_pattern": "현수막 무늬",
  "item.minecraft.flow_banner_pattern.desc": "흐름",
  "item.minecraft.flow_banner_pattern.new": "흐름 현수막 무늬",
  "item.minecraft.flow_pottery_sherd": "흐름 도자기 조각",
  "item.minecraft.flower_banner_pattern": "현수막 무늬",
  "item.minecraft.flower_banner_pattern.desc": "꽃 모양",
  "item.minecraft.flower_banner_pattern.new": "꽃 모양 현수막 무늬",
  "item.minecraft.flower_pot": "화분",
  "item.minecraft.fox_spawn_egg": "여우 생성 알",
  "item.minecraft.friend_pottery_shard": "친구 도자기 조각",
  "item.minecraft.friend_pottery_sherd": "친구 도자기 조각",
  "item.minecraft.frog_spawn_egg": "개구리 생성 알",
  "item.minecraft.furnace_minecart": "화로가 실린 광산 수레",
  "item.minecraft.ghast_spawn_egg": "가스트 생성 알",
  "item.minecraft.ghast_tear": "가스트 눈물",
  "item.minecraft.glass_bottle": "유리병",
  "item.minecraft.glistering_melon_slice": "반짝이는 수박 조각",
  "item.minecraft.globe_banner_pattern": "현수막 무늬",
  "item.minecraft.globe_banner_pattern.desc": "지구 모양",
  "item.minecraft.globe_banner_pattern.new": "지구 모양 현수막 무늬",
  "item.minecraft.glow_berries": "발광 열매",
  "item.minecraft.glow_ink_sac": "발광 먹물 주머니",
  "item.minecraft.glow_item_frame": "발광 아이템 액자",
  "item.minecraft.glow_squid_spawn_egg": "발광 오징어 생성 알",
  "item.minecraft.glowstone_dust": "발광석 가루",
  "item.minecraft.goat_horn": "염소 뿔",
  "item.minecraft.goat_spawn_egg": "염소 생성 알",
  "item.minecraft.gold_ingot": "금 주괴",
  "item.minecraft.gold_nugget": "금 조각",
  "item.minecraft.golden_apple": "황금 사과",
  "item.minecraft.golden_axe": "금 도끼",
  "item.minecraft.golden_boots": "금 부츠",
  "item.minecraft.golden_carrot": "황금 당근",
  "item.minecraft.golden_chestplate": "금 흉갑",
  "item.minecraft.golden_helmet": "금 투구",
  "item.minecraft.golden_hoe": "금 괭이",
  "item.minecraft.golden_horse_armor": "금 말 갑옷",
  "item.minecraft.golden_leggings": "금 레깅스",
  "item.minecraft.golden_nautilus_armor": "금 앵무조개 갑옷",
  "item.minecraft.golden_pickaxe": "금 곡괭이",
  "item.minecraft.golden_shovel": "금 삽",
  "item.minecraft.golden_spear": "금 창",
  "item.minecraft.golden_sword": "금 검",
  "item.minecraft.gray_bundle": "회색 꾸러미",
  "item.minecraft.gray_dye": "회색 염료",
  "item.minecraft.gray_harness": "회색 하네스",
  "item.minecraft.green_bundle": "초록색 꾸러미",
  "item.minecraft.green_dye": "초록색 염료",
  "item.minecraft.green_harness": "초록색 하네스",
  "item.minecraft.guardian_spawn_egg": "가디언 생성 알",
  "item.minecraft.gunpowder": "화약",
  "item.minecraft.guster_banner_pattern": "현수막 무늬",
  "item.minecraft.guster_banner_pattern.desc": "소용돌이",
  "item.minecraft.guster_banner_pattern.new": "소용돌이 현수막 무늬",
  "item.minecraft.guster_pottery_sherd": "소용돌이 도자기 조각",
  "item.minecraft.happy_ghast_spawn_egg": "행복한 가스트 생성 알",
  "item.minecraft.harness": "하네스",
  "item.minecraft.heart_of_the_sea": "바다의 심장",
  "item.minecraft.heart_pottery_shard": "심장 도자기 조각",
  "item.minecraft.heart_pottery_sherd": "심장 도자기 조각",
  "item.minecraft.heartbreak_pottery_shard": "찢어진 심장 도자기 조각",
  "item.minecraft.heartbreak_pottery_sherd": "찢어진 심장 도자기 조각",
  "item.minecraft.hoglin_spawn_egg": "호글린 생성 알",
  "item.minecraft.honey_bottle": "꿀이 든 병",
  "item.minecraft.honeycomb": "벌집 조각",
  "item.minecraft.hopper_minecart": "호퍼가 실린 광산 수레",
  "item.minecraft.horse_spawn_egg": "말 생성 알",
  "item.minecraft.host_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.host_armor_trim_smithing_template.new": "주인 갑옷 장식",
  "item.minecraft.howl_pottery_shard": "짖음 도자기 조각",
  "item.minecraft.howl_pottery_sherd": "짖음 도자기 조각",
  "item.minecraft.husk_spawn_egg": "허스크 생성 알",
  "item.minecraft.ink_sac": "먹물 주머니",
  "item.minecraft.iron_axe": "철 도끼",
  "item.minecraft.iron_boots": "철 부츠",
  "item.minecraft.iron_chestplate": "철 흉갑",
  "item.minecraft.iron_golem_spawn_egg": "철 골렘 생성 알",
  "item.minecraft.iron_helmet": "철 투구",
  "item.minecraft.iron_hoe": "철 괭이",
  "item.minecraft.iron_horse_armor": "철 말 갑옷",
  "item.minecraft.iron_ingot": "철 주괴",
  "item.minecraft.iron_leggings": "철 레깅스",
  "item.minecraft.iron_nautilus_armor": "철 앵무조개 갑옷",
  "item.minecraft.iron_nugget": "철 조각",
  "item.minecraft.iron_pickaxe": "철 곡괭이",
  "item.minecraft.iron_shovel": "철 삽",
  "item.minecraft.iron_spear": "철 창",
  "item.minecraft.iron_sword": "철 검",
  "item.minecraft.item_frame": "아이템 액자",
  "item.minecraft.jungle_boat": "정글나무 보트",
  "item.minecraft.jungle_chest_boat": "상자가 실린 정글나무 보트",
  "item.minecraft.knowledge_book": "지식의 책",
  "item.minecraft.lapis_lazuli": "청금석",
  "item.minecraft.lava_bucket": "용암 양동이",
  "item.minecraft.lead": "끈",
  "item.minecraft.leather": "가죽",
  "item.minecraft.leather_boots": "가죽 장화",
  "item.minecraft.leather_chestplate": "가죽 조끼",
  "item.minecraft.leather_helmet": "가죽 모자",
  "item.minecraft.leather_horse_armor": "가죽 말 갑옷",
  "item.minecraft.leather_leggings": "가죽 바지",
  "item.minecraft.light_blue_bundle": "하늘색 꾸러미",
  "item.minecraft.light_blue_dye": "하늘색 염료",
  "item.minecraft.light_blue_harness": "하늘색 하네스",
  "item.minecraft.light_gray_bundle": "회백색 꾸러미",
  "item.minecraft.light_gray_dye": "회백색 염료",
  "item.minecraft.light_gray_harness": "회백색 하네스",
  "item.minecraft.lime_bundle": "연두색 꾸러미",
  "item.minecraft.lime_dye": "연두색 염료",
  "item.minecraft.lime_harness": "연두색 하네스",
  "item.minecraft.lingering_potion": "잔류형 물약",
  "item.minecraft.lingering_potion.effect.awkward": "잔류형 어색한 물약",
  "item.minecraft.lingering_potion.effect.empty": "잔류형 제작 불가능 물약",
  "item.minecraft.lingering_potion.effect.fire_resistance": "잔류형 화염 저항의 물약",
  "item.minecraft.lingering_potion.effect.harming": "잔류형 고통의 물약",
  "item.minecraft.lingering_potion.effect.healing": "잔류형 치유의 물약",
  "item.minecraft.lingering_potion.effect.infested": "잔류형 벌레 먹음의 물약",
  "item.minecraft.lingering_potion.effect.invisibility": "잔류형 투명화 물약",
  "item.minecraft.lingering_potion.effect.leaping": "잔류형 도약의 물약",
  "item.minecraft.lingering_potion.effect.levitation": "잔류형 공중 부양의 물약",
  "item.minecraft.lingering_potion.effect.luck": "잔류형 행운의 물약",
  "item.minecraft.lingering_potion.effect.mundane": "잔류형 평범한 물약",
  "item.minecraft.lingering_potion.effect.night_vision": "잔류형 야간 투시의 물약",
  "item.minecraft.lingering_potion.effect.oozing": "잔류형 점액화 물약",
  "item.minecraft.lingering_potion.effect.poison": "잔류형 독 물약",
  "item.minecraft.lingering_potion.effect.regeneration": "잔류형 재생의 물약",
  "item.minecraft.lingering_potion.effect.slow_falling": "잔류형 느린 낙하의 물약",
  "item.minecraft.lingering_potion.effect.slowness": "잔류형 감속의 물약",
  "item.minecraft.lingering_potion.effect.strength": "잔류형 힘의 물약",
  "item.minecraft.lingering_potion.effect.swiftness": "잔류형 신속의 물약",
  "item.minecraft.lingering_potion.effect.thick": "잔류형 진한 물약",
  "item.minecraft.lingering_potion.effect.turtle_master": "잔류형 거북 도사의 물약",
  "item.minecraft.lingering_potion.effect.water": "잔류형 물병",
  "item.minecraft.lingering_potion.effect.water_breathing": "잔류형 수중 호흡의 물약",
  "item.minecraft.lingering_potion.effect.weakness": "잔류형 나약함의 물약",
  "item.minecraft.lingering_potion.effect.weaving": "잔류형 방적의 물약",
  "item.minecraft.lingering_potion.effect.wind_charged": "잔류형 돌풍의 물약",
  "item.minecraft.llama_spawn_egg": "라마 생성 알",
  "item.minecraft.lodestone_compass": "자석석 나침반",
  "item.minecraft.mace": "철퇴",
  "item.minecraft.magenta_bundle": "자홍색 꾸러미",
  "item.minecraft.magenta_dye": "자홍색 염료",
  "item.minecraft.magenta_harness": "자홍색 하네스",
  "item.minecraft.magma_cream": "마그마 크림",
  "item.minecraft.magma_cube_spawn_egg": "마그마 큐브 생성 알",
  "item.minecraft.mangrove_boat": "맹그로브나무 보트",
  "item.minecraft.mangrove_chest_boat": "상자가 실린 맹그로브나무 보트",
  "item.minecraft.map": "빈 지도",
  "item.minecraft.melon_seeds": "수박씨",
  "item.minecraft.melon_slice": "수박 조각",
  "item.minecraft.milk_bucket": "우유 양동이",
  "item.minecraft.minecart": "광산 수레",
  "item.minecraft.miner_pottery_shard": "광부 도자기 조각",
  "item.minecraft.miner_pottery_sherd": "광부 도자기 조각",
  "item.minecraft.mojang_banner_pattern": "현수막 무늬",
  "item.minecraft.mojang_banner_pattern.desc": "무언가",
  "item.minecraft.mojang_banner_pattern.new": "무언가 현수막 무늬",
  "item.minecraft.mooshroom_spawn_egg": "무시룸 생성 알",
  "item.minecraft.mourner_pottery_shard": "애도자 도자기 조각",
  "item.minecraft.mourner_pottery_sherd": "애도자 도자기 조각",
  "item.minecraft.mule_spawn_egg": "노새 생성 알",
  "item.minecraft.mushroom_stew": "버섯 스튜",
  "item.minecraft.music_disc_11": "음반",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "음반",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "음반",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "음반",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "음반",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "음반",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "음반",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "음반",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (오르골)",
  "item.minecraft.music_disc_far": "음반",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "음반",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "음반",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "음반",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "음반",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "음반",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "음반",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "음반",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "음반",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "음반",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "음반",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "음반",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "음반",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "익히지 않은 양고기",
  "item.minecraft.name_tag": "이름표",
  "item.minecraft.nautilus_shell": "앵무조개 껍데기",
  "item.minecraft.nautilus_spawn_egg": "앵무조개 생성 알",
  "item.minecraft.nether_brick": "네더 벽돌",
  "item.minecraft.nether_star": "네더의 별",
  "item.minecraft.nether_wart": "네더 사마귀",
  "item.minecraft.netherite_axe": "네더라이트 도끼",
  "item.minecraft.netherite_boots": "네더라이트 부츠",
  "item.minecraft.netherite_chestplate": "네더라이트 흉갑",
  "item.minecraft.netherite_helmet": "네더라이트 투구",
  "item.minecraft.netherite_hoe": "네더라이트 괭이",
  "item.minecraft.netherite_horse_armor": "네더라이트 말 갑옷",
  "item.minecraft.netherite_ingot": "네더라이트 주괴",
  "item.minecraft.netherite_leggings": "네더라이트 레깅스",
  "item.minecraft.netherite_nautilus_armor": "네더라이트 앵무조개 갑옷",
  "item.minecraft.netherite_pickaxe": "네더라이트 곡괭이",
  "item.minecraft.netherite_scrap": "네더라이트 파편",
  "item.minecraft.netherite_shovel": "네더라이트 삽",
  "item.minecraft.netherite_spear": "네더라이트 창",
  "item.minecraft.netherite_sword": "네더라이트 검",
  "item.minecraft.netherite_upgrade_smithing_template": "대장장이 형판",
  "item.minecraft.netherite_upgrade_smithing_template.new": "네더라이트 강화",
  "item.minecraft.oak_boat": "참나무 보트",
  "item.minecraft.oak_chest_boat": "상자가 실린 참나무 보트",
  "item.minecraft.ocelot_spawn_egg": "오실롯 생성 알",
  "item.minecraft.ominous_bottle": "불길한 병",
  "item.minecraft.ominous_trial_key": "불길한 시련 열쇠",
  "item.minecraft.orange_bundle": "주황색 꾸러미",
  "item.minecraft.orange_dye": "주황색 염료",
  "item.minecraft.orange_harness": "주황색 하네스",
  "item.minecraft.painting": "그림",
  "item.minecraft.pale_oak_boat": "창백한 참나무 보트",
  "item.minecraft.pale_oak_chest_boat": "상자가 실린 창백한 참나무 보트",
  "item.minecraft.panda_spawn_egg": "판다 생성 알",
  "item.minecraft.paper": "종이",
  "item.minecraft.parched_spawn_egg": "파치트 생성 알",
  "item.minecraft.parrot_spawn_egg": "앵무새 생성 알",
  "item.minecraft.phantom_membrane": "팬텀 막",
  "item.minecraft.phantom_spawn_egg": "팬텀 생성 알",
  "item.minecraft.pig_spawn_egg": "돼지 생성 알",
  "item.minecraft.piglin_banner_pattern": "현수막 무늬",
  "item.minecraft.piglin_banner_pattern.desc": "돼지 코",
  "item.minecraft.piglin_banner_pattern.new": "돼지 코 현수막 무늬",
  "item.minecraft.piglin_brute_spawn_egg": "난폭한 피글린 생성 알",
  "item.minecraft.piglin_spawn_egg": "피글린 생성 알",
  "item.minecraft.pillager_spawn_egg": "약탈자 생성 알",
  "item.minecraft.pink_bundle": "분홍색 꾸러미",
  "item.minecraft.pink_dye": "분홍색 염료",
  "item.minecraft.pink_harness": "분홍색 하네스",
  "item.minecraft.pitcher_plant": "벌레잡이풀",
  "item.minecraft.pitcher_pod": "벌레잡이풀 꼬투리",
  "item.minecraft.plenty_pottery_shard": "풍부 도자기 조각",
  "item.minecraft.plenty_pottery_sherd": "풍부 도자기 조각",
  "item.minecraft.poisonous_potato": "독이 있는 감자",
  "item.minecraft.polar_bear_spawn_egg": "북극곰 생성 알",
  "item.minecraft.popped_chorus_fruit": "튀긴 후렴과",
  "item.minecraft.porkchop": "익히지 않은 돼지고기",
  "item.minecraft.potato": "감자",
  "item.minecraft.potion": "물약",
  "item.minecraft.potion.effect.awkward": "어색한 물약",
  "item.minecraft.potion.effect.empty": "제작 불가능 물약",
  "item.minecraft.potion.effect.fire_resistance": "화염 저항의 물약",
  "item.minecraft.potion.effect.harming": "고통의 물약",
  "item.minecraft.potion.effect.healing": "치유의 물약",
  "item.minecraft.potion.effect.infested": "벌레 먹음의 물약",
  "item.minecraft.potion.effect.invisibility": "투명화 물약",
  "item.minecraft.potion.effect.leaping": "도약의 물약",
  "item.minecraft.potion.effect.levitation": "공중 부양의 물약",
  "item.minecraft.potion.effect.luck": "행운의 물약",
  "item.minecraft.potion.effect.mundane": "평범한 물약",
  "item.minecraft.potion.effect.night_vision": "야간 투시의 물약",
  "item.minecraft.potion.effect.oozing": "점액화 물약",
  "item.minecraft.potion.effect.poison": "독 물약",
  "item.minecraft.potion.effect.regeneration": "재생의 물약",
  "item.minecraft.potion.effect.slow_falling": "느린 낙하의 물약",
  "item.minecraft.potion.effect.slowness": "감속의 물약",
  "item.minecraft.potion.effect.strength": "힘의 물약",
  "item.minecraft.potion.effect.swiftness": "신속의 물약",
  "item.minecraft.potion.effect.thick": "진한 물약",
  "item.minecraft.potion.effect.turtle_master": "거북 도사의 물약",
  "item.minecraft.potion.effect.water": "물병",
  "item.minecraft.potion.effect.water_breathing": "수중 호흡의 물약",
  "item.minecraft.potion.effect.weakness": "나약함의 물약",
  "item.minecraft.potion.effect.weaving": "방적의 물약",
  "item.minecraft.potion.effect.wind_charged": "돌풍의 물약",
  "item.minecraft.pottery_shard_archer": "궁수 도자기 조각",
  "item.minecraft.pottery_shard_arms_up": "만세 도자기 조각",
  "item.minecraft.pottery_shard_prize": "보물 도자기 조각",
  "item.minecraft.pottery_shard_skull": "해골 도자기 조각",
  "item.minecraft.powder_snow_bucket": "가루눈 양동이",
  "item.minecraft.prismarine_crystals": "프리즈머린 수정",
  "item.minecraft.prismarine_shard": "프리즈머린 조각",
  "item.minecraft.prize_pottery_shard": "보물 도자기 조각",
  "item.minecraft.prize_pottery_sherd": "보물 도자기 조각",
  "item.minecraft.pufferfish": "복어",
  "item.minecraft.pufferfish_bucket": "복어가 담긴 양동이",
  "item.minecraft.pufferfish_spawn_egg": "복어 생성 알",
  "item.minecraft.pumpkin_pie": "호박 파이",
  "item.minecraft.pumpkin_seeds": "호박씨",
  "item.minecraft.purple_bundle": "보라색 꾸러미",
  "item.minecraft.purple_dye": "보라색 염료",
  "item.minecraft.purple_harness": "보라색 하네스",
  "item.minecraft.quartz": "네더 석영",
  "item.minecraft.rabbit": "익히지 않은 토끼고기",
  "item.minecraft.rabbit_foot": "토끼발",
  "item.minecraft.rabbit_hide": "토끼 가죽",
  "item.minecraft.rabbit_spawn_egg": "토끼 생성 알",
  "item.minecraft.rabbit_stew": "토끼 스튜",
  "item.minecraft.raiser_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "사육사 갑옷 장식",
  "item.minecraft.ravager_spawn_egg": "파괴수 생성 알",
  "item.minecraft.raw_copper": "구리 원석",
  "item.minecraft.raw_gold": "금 원석",
  "item.minecraft.raw_iron": "철 원석",
  "item.minecraft.recovery_compass": "만회 나침반",
  "item.minecraft.red_bundle": "빨간색 꾸러미",
  "item.minecraft.red_dye": "빨간색 염료",
  "item.minecraft.red_harness": "빨간색 하네스",
  "item.minecraft.redstone": "레드스톤 가루",
  "item.minecraft.resin_brick": "수지 벽돌",
  "item.minecraft.resin_clump": "수지 덩어리",
  "item.minecraft.rib_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.rib_armor_trim_smithing_template.new": "갈비뼈 갑옷 장식",
  "item.minecraft.rotten_flesh": "썩은 살점",
  "item.minecraft.saddle": "안장",
  "item.minecraft.salmon": "익히지 않은 연어",
  "item.minecraft.salmon_bucket": "연어가 담긴 양동이",
  "item.minecraft.salmon_spawn_egg": "연어 생성 알",
  "item.minecraft.scrape_pottery_sherd": "긁개 도자기 조각",
  "item.minecraft.scute": "인갑",
  "item.minecraft.sentry_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "보초 갑옷 장식",
  "item.minecraft.shaper_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "조형가 갑옷 장식",
  "item.minecraft.sheaf_pottery_shard": "다발 도자기 조각",
  "item.minecraft.sheaf_pottery_sherd": "다발 도자기 조각",
  "item.minecraft.shears": "가위",
  "item.minecraft.sheep_spawn_egg": "양 생성 알",
  "item.minecraft.shelter_pottery_shard": "피신처 도자기 조각",
  "item.minecraft.shelter_pottery_sherd": "피신처 도자기 조각",
  "item.minecraft.shield": "방패",
  "item.minecraft.shield.black": "검은색 방패",
  "item.minecraft.shield.blue": "파란색 방패",
  "item.minecraft.shield.brown": "갈색 방패",
  "item.minecraft.shield.cyan": "청록색 방패",
  "item.minecraft.shield.gray": "회색 방패",
  "item.minecraft.shield.green": "초록색 방패",
  "item.minecraft.shield.light_blue": "하늘색 방패",
  "item.minecraft.shield.light_gray": "회백색 방패",
  "item.minecraft.shield.lime": "연두색 방패",
  "item.minecraft.shield.magenta": "자홍색 방패",
  "item.minecraft.shield.orange": "주황색 방패",
  "item.minecraft.shield.pink": "분홍색 방패",
  "item.minecraft.shield.purple": "보라색 방패",
  "item.minecraft.shield.red": "빨간색 방패",
  "item.minecraft.shield.white": "하얀색 방패",
  "item.minecraft.shield.yellow": "노란색 방패",
  "item.minecraft.shulker_shell": "셜커 껍데기",
  "item.minecraft.shulker_spawn_egg": "셜커 생성 알",
  "item.minecraft.sign": "표지판",
  "item.minecraft.silence_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.silence_armor_trim_smithing_template.new": "고요 갑옷 장식",
  "item.minecraft.silverfish_spawn_egg": "좀벌레 생성 알",
  "item.minecraft.skeleton_horse_spawn_egg": "스켈레톤 말 생성 알",
  "item.minecraft.skeleton_spawn_egg": "스켈레톤 생성 알",
  "item.minecraft.skull_banner_pattern": "현수막 무늬",
  "item.minecraft.skull_banner_pattern.desc": "해골 모양",
  "item.minecraft.skull_banner_pattern.new": "해골 모양 현수막 무늬",
  "item.minecraft.skull_pottery_shard": "해골 도자기 조각",
  "item.minecraft.skull_pottery_sherd": "해골 도자기 조각",
  "item.minecraft.slime_ball": "슬라임볼",
  "item.minecraft.slime_spawn_egg": "슬라임 생성 알",
  "item.minecraft.smithing_template": "대장장이 형판",
  "item.minecraft.smithing_template.applies_to": "적용 대상:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "주괴나 수정을 놓으세요",
  "item.minecraft.smithing_template.armor_trim.applies_to": "갑옷",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "갑옷을 놓으세요",
  "item.minecraft.smithing_template.armor_trim.ingredients": "주괴 및 수정",
  "item.minecraft.smithing_template.ingredients": "재료:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "네더라이트 주괴를 놓으세요",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "다이아몬드 장비",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "다이아몬드 갑옷이나 무기, 도구를 놓으세요",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "네더라이트 주괴",
  "item.minecraft.smithing_template.upgrade": "강화: ",
  "item.minecraft.sniffer_spawn_egg": "스니퍼 생성 알",
  "item.minecraft.snort_pottery_shard": "콧바람 도자기 조각",
  "item.minecraft.snort_pottery_sherd": "콧바람 도자기 조각",
  "item.minecraft.snout_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.snout_armor_trim_smithing_template.new": "돼지 코 갑옷 장식",
  "item.minecraft.snow_golem_spawn_egg": "눈 골렘 생성 알",
  "item.minecraft.snowball": "눈덩이",
  "item.minecraft.spectral_arrow": "분광 화살",
  "item.minecraft.spider_eye": "거미 눈",
  "item.minecraft.spider_spawn_egg": "거미 생성 알",
  "item.minecraft.spire_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.spire_armor_trim_smithing_template.new": "첨탑 갑옷 장식",
  "item.minecraft.splash_potion": "투척용 물약",
  "item.minecraft.splash_potion.effect.awkward": "투척용 어색한 물약",
  "item.minecraft.splash_potion.effect.empty": "투척용 제작 불가능 물약",
  "item.minecraft.splash_potion.effect.fire_resistance": "투척용 화염 저항의 물약",
  "item.minecraft.splash_potion.effect.harming": "투척용 고통의 물약",
  "item.minecraft.splash_potion.effect.healing": "투척용 치유의 물약",
  "item.minecraft.splash_potion.effect.infested": "투척용 벌레 먹음의 물약",
  "item.minecraft.splash_potion.effect.invisibility": "투척용 투명화 물약",
  "item.minecraft.splash_potion.effect.leaping": "투척용 도약의 물약",
  "item.minecraft.splash_potion.effect.levitation": "투척용 공중 부양의 물약",
  "item.minecraft.splash_potion.effect.luck": "투척용 행운의 물약",
  "item.minecraft.splash_potion.effect.mundane": "투척용 평범한 물약",
  "item.minecraft.splash_potion.effect.night_vision": "투척용 야간 투시의 물약",
  "item.minecraft.splash_potion.effect.oozing": "투척용 점액화 물약",
  "item.minecraft.splash_potion.effect.poison": "투척용 독 물약",
  "item.minecraft.splash_potion.effect.regeneration": "투척용 재생의 물약",
  "item.minecraft.splash_potion.effect.slow_falling": "투척용 느린 낙하의 물약",
  "item.minecraft.splash_potion.effect.slowness": "투척용 감속의 물약",
  "item.minecraft.splash_potion.effect.strength": "투척용 힘의 물약",
  "item.minecraft.splash_potion.effect.swiftness": "투척용 신속의 물약",
  "item.minecraft.splash_potion.effect.thick": "투척용 진한 물약",
  "item.minecraft.splash_potion.effect.turtle_master": "투척용 거북 도사의 물약",
  "item.minecraft.splash_potion.effect.water": "투척용 물병",
  "item.minecraft.splash_potion.effect.water_breathing": "투척용 수중 호흡의 물약",
  "item.minecraft.splash_potion.effect.weakness": "투척용 나약함의 물약",
  "item.minecraft.splash_potion.effect.weaving": "투척용 방적의 물약",
  "item.minecraft.splash_potion.effect.wind_charged": "투척용 돌풍의 물약",
  "item.minecraft.spruce_boat": "가문비나무 보트",
  "item.minecraft.spruce_chest_boat": "상자가 실린 가문비나무 보트",
  "item.minecraft.spyglass": "망원경",
  "item.minecraft.squid_spawn_egg": "오징어 생성 알",
  "item.minecraft.stick": "막대기",
  "item.minecraft.stone_axe": "돌 도끼",
  "item.minecraft.stone_hoe": "돌 괭이",
  "item.minecraft.stone_pickaxe": "돌 곡괭이",
  "item.minecraft.stone_shovel": "돌 삽",
  "item.minecraft.stone_spear": "돌 창",
  "item.minecraft.stone_sword": "돌 검",
  "item.minecraft.stray_spawn_egg": "스트레이 생성 알",
  "item.minecraft.strider_spawn_egg": "스트라이더 생성 알",
  "item.minecraft.string": "실",
  "item.minecraft.sugar": "설탕",
  "item.minecraft.suspicious_stew": "수상한 스튜",
  "item.minecraft.sweet_berries": "달콤한 열매",
  "item.minecraft.tadpole_bucket": "올챙이가 담긴 양동이",
  "item.minecraft.tadpole_spawn_egg": "올챙이 생성 알",
  "item.minecraft.tide_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.tide_armor_trim_smithing_template.new": "물결 갑옷 장식",
  "item.minecraft.tipped_arrow": "물약이 묻은 화살",
  "item.minecraft.tipped_arrow.effect.awkward": "물약이 묻은 화살",
  "item.minecraft.tipped_arrow.effect.empty": "물약이 묻은 제작 불가능 화살",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "화염 저항의 화살",
  "item.minecraft.tipped_arrow.effect.harming": "고통의 화살",
  "item.minecraft.tipped_arrow.effect.healing": "치유의 화살",
  "item.minecraft.tipped_arrow.effect.infested": "벌레 먹음의 화살",
  "item.minecraft.tipped_arrow.effect.invisibility": "투명화 화살",
  "item.minecraft.tipped_arrow.effect.leaping": "도약의 화살",
  "item.minecraft.tipped_arrow.effect.levitation": "공중 부양의 화살",
  "item.minecraft.tipped_arrow.effect.luck": "행운의 화살",
  "item.minecraft.tipped_arrow.effect.mundane": "물약이 묻은 화살",
  "item.minecraft.tipped_arrow.effect.night_vision": "야간 투시의 화살",
  "item.minecraft.tipped_arrow.effect.oozing": "점액화 화살",
  "item.minecraft.tipped_arrow.effect.poison": "독 화살",
  "item.minecraft.tipped_arrow.effect.regeneration": "재생의 화살",
  "item.minecraft.tipped_arrow.effect.slow_falling": "느린 낙하의 화살",
  "item.minecraft.tipped_arrow.effect.slowness": "감속의 화살",
  "item.minecraft.tipped_arrow.effect.strength": "힘의 화살",
  "item.minecraft.tipped_arrow.effect.swiftness": "신속의 화살",
  "item.minecraft.tipped_arrow.effect.thick": "물약이 묻은 화살",
  "item.minecraft.tipped_arrow.effect.turtle_master": "거북 도사의 화살",
  "item.minecraft.tipped_arrow.effect.water": "분무 화살",
  "item.minecraft.tipped_arrow.effect.water_breathing": "수중 호흡의 화살",
  "item.minecraft.tipped_arrow.effect.weakness": "나약함의 화살",
  "item.minecraft.tipped_arrow.effect.weaving": "방적의 화살",
  "item.minecraft.tipped_arrow.effect.wind_charged": "돌풍의 화살",
  "item.minecraft.tnt_minecart": "TNT가 실린 광산 수레",
  "item.minecraft.torchflower_seeds": "횃불꽃 씨앗",
  "item.minecraft.totem_of_undying": "불사의 토템",
  "item.minecraft.trader_llama_spawn_egg": "상인 라마 생성 알",
  "item.minecraft.trial_key": "시련 열쇠",
  "item.minecraft.trident": "삼지창",
  "item.minecraft.tropical_fish": "열대어",
  "item.minecraft.tropical_fish_bucket": "열대어가 담긴 양동이",
  "item.minecraft.tropical_fish_spawn_egg": "열대어 생성 알",
  "item.minecraft.turtle_helmet": "거북 등딱지",
  "item.minecraft.turtle_scute": "거북 인갑",
  "item.minecraft.turtle_spawn_egg": "거북 생성 알",
  "item.minecraft.vex_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.vex_armor_trim_smithing_template.new": "벡스 갑옷 장식",
  "item.minecraft.vex_spawn_egg": "벡스 생성 알",
  "item.minecraft.villager_spawn_egg": "주민 생성 알",
  "item.minecraft.vindicator_spawn_egg": "변명자 생성 알",
  "item.minecraft.wandering_trader_spawn_egg": "떠돌이 상인 생성 알",
  "item.minecraft.ward_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.ward_armor_trim_smithing_template.new": "파수 갑옷 장식",
  "item.minecraft.warden_spawn_egg": "워든 생성 알",
  "item.minecraft.warped_fungus_on_a_stick": "뒤틀린 균 낚싯대",
  "item.minecraft.water_bucket": "물 양동이",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "길잡이 갑옷 장식",
  "item.minecraft.wheat": "밀",
  "item.minecraft.wheat_seeds": "밀 씨앗",
  "item.minecraft.white_bundle": "하얀색 꾸러미",
  "item.minecraft.white_dye": "하얀색 염료",
  "item.minecraft.white_harness": "하얀색 하네스",
  "item.minecraft.wild_armor_trim_smithing_template": "대장장이 형판",
  "item.minecraft.wild_armor_trim_smithing_template.new": "야생 갑옷 장식",
  "item.minecraft.wind_charge": "돌풍구",
  "item.minecraft.witch_spawn_egg": "마녀 생성 알",
  "item.minecraft.wither_skeleton_spawn_egg": "위더 스켈레톤 생성 알",
  "item.minecraft.wither_spawn_egg": "위더 생성 알",
  "item.minecraft.wolf_armor": "늑대 갑옷",
  "item.minecraft.wolf_spawn_egg": "늑대 생성 알",
  "item.minecraft.wooden_axe": "나무 도끼",
  "item.minecraft.wooden_hoe": "나무 괭이",
  "item.minecraft.wooden_pickaxe": "나무 곡괭이",
  "item.minecraft.wooden_shovel": "나무 삽",
  "item.minecraft.wooden_spear": "나무 창",
  "item.minecraft.wooden_sword": "나무 검",
  "item.minecraft.writable_book": "책과 깃펜",
  "item.minecraft.written_book": "글이 쓰인 책",
  "item.minecraft.yellow_bundle": "노란색 꾸러미",
  "item.minecraft.yellow_dye": "노란색 염료",
  "item.minecraft.yellow_harness": "노란색 하네스",
  "item.minecraft.zoglin_spawn_egg": "조글린 생성 알",
  "item.minecraft.zombie_horse_spawn_egg": "좀비 말 생성 알",
  "item.minecraft.zombie_nautilus_spawn_egg": "좀비 앵무조개 생성 알",
  "item.minecraft.zombie_spawn_egg": "좀비 생성 알",
  "item.minecraft.zombie_villager_spawn_egg": "좀비 주민 생성 알",
  "item.minecraft.zombified_piglin_spawn_egg": "좀비화 피글린 생성 알"
}
export const ko_kr = items; 
